// src/types/game.ts
import { z as z4 } from "zod";

// src/types/card.ts
import { z as z2 } from "zod";

// src/types/special-card.ts
import { z } from "zod";
var SpecialCardType = /* @__PURE__ */ ((SpecialCardType4) => {
  SpecialCardType4["CHAMELEON"] = "chameleon";
  SpecialCardType4["NUMEROLOGY"] = "numerology";
  SpecialCardType4["SUITOR"] = "suitor";
  SpecialCardType4["IMPERSONATOR"] = "impersonator";
  SpecialCardType4["ANCHOR"] = "anchor";
  SpecialCardType4["HIGHFLYER"] = "highflyer";
  SpecialCardType4["ORACLE"] = "oracle";
  SpecialCardType4["SEER"] = "seer";
  SpecialCardType4["THIEF"] = "thief";
  SpecialCardType4["JEWELER"] = "jeweler";
  SpecialCardType4["JOKER"] = "joker";
  SpecialCardType4["SOOTHSAYER"] = "soothsayer";
  SpecialCardType4["SPY"] = "spy";
  SpecialCardType4["OMNIPOTENT"] = "omnipotent";
  SpecialCardType4["GHOST"] = "ghost";
  SpecialCardType4["ORPHAN"] = "orphan";
  SpecialCardType4["VOID"] = "void";
  SpecialCardType4["CROSSED"] = "crossed";
  SpecialCardType4["LIMBO"] = "limbo";
  SpecialCardType4["SNARE"] = "snare";
  SpecialCardType4["FLAWED"] = "flawed";
  SpecialCardType4["FRAY"] = "fray";
  SpecialCardType4["PRANK"] = "prank";
  SpecialCardType4["BLIND"] = "blind";
  SpecialCardType4["BURIED"] = "buried";
  SpecialCardType4["ORIGAMI"] = "origami";
  SpecialCardType4["HELLRAISER"] = "hellraiser";
  SpecialCardType4["COMMENTATOR"] = "commentator";
  return SpecialCardType4;
})(SpecialCardType || {});
var SpecialCardSign = /* @__PURE__ */ ((SpecialCardSign2) => {
  SpecialCardSign2["POSITIVE"] = "positive";
  SpecialCardSign2["NEGATIVE"] = "negative";
  return SpecialCardSign2;
})(SpecialCardSign || {});
var SPECIAL_CARD_INFO = {
  ["chameleon" /* CHAMELEON */]: {
    type: "chameleon" /* CHAMELEON */,
    name: "Chameleon",
    sign: "positive" /* POSITIVE */,
    tier: 3,
    description: "Jewel stays undetermined until showdown, then locks to whichever jewel makes the hand strongest. Rank and suit are fixed and real."
  },
  ["numerology" /* NUMEROLOGY */]: {
    type: "numerology" /* NUMEROLOGY */,
    name: "Numerology",
    sign: "positive" /* POSITIVE */,
    tier: 2,
    description: "Copies the rank of the player's other hole card. Real suit and jewel retained. Resolves instantly at deal."
  },
  ["suitor" /* SUITOR */]: {
    type: "suitor" /* SUITOR */,
    name: "Suitor",
    sign: "positive" /* POSITIVE */,
    tier: 1,
    description: "Copies the suit of the player's other hole card. Real rank and jewel retained. Resolves instantly at deal."
  },
  ["impersonator" /* IMPERSONATOR */]: {
    type: "impersonator" /* IMPERSONATOR */,
    name: "Impersonator",
    sign: "positive" /* POSITIVE */,
    tier: 2,
    description: "Becomes a full duplicate (rank + suit + jewel) of whatever card lands in the center cell, once revealed. Resolves last, with full information."
  },
  ["anchor" /* ANCHOR */]: {
    type: "anchor" /* ANCHOR */,
    name: "Anchor",
    sign: "positive" /* POSITIVE */,
    tier: 2,
    description: `Expands the player's searchable line-set from the 8 standard lines to 22 "snake" shapes (6 straight rows/columns + 16 orthogonally-connected L-shapes). Drops both diagonals \u2014 a genuine trade-off, not a strict upgrade.`
  },
  ["highflyer" /* HIGHFLYER */]: {
    type: "highflyer" /* HIGHFLYER */,
    name: "Highflyer",
    sign: "positive" /* POSITIVE */,
    tier: 3,
    description: "Becomes a copy of whichever card has the highest rank among the 3 cells in the line currently being evaluated. Keeps own suit/jewel. Not self-optimizing \u2014 always grabs the highest number even when a different result would score better."
  },
  ["oracle" /* ORACLE */]: {
    type: "oracle" /* ORACLE */,
    name: "Oracle",
    sign: "positive" /* POSITIVE */,
    tier: 2,
    description: `Triggers right after the diamond reveal, before the center card turns. Shows the holder the rank and suit of every other player's hole cards (not their jewel). Any that are themselves special cards show as an unrevealed "?" \u2014 only that something special is there.`
  },
  ["seer" /* SEER */]: {
    type: "seer" /* SEER */,
    name: "Seer",
    sign: "positive" /* POSITIVE */,
    tier: 2,
    description: "Held as a hole card. Privately reveals the center cell to its holder the moment the 4 corners finish revealing \u2014 well before it turns for everyone else."
  },
  ["thief" /* THIEF */]: {
    type: "thief" /* THIEF */,
    name: "Thief",
    sign: "positive" /* POSITIVE */,
    tier: 2,
    description: `Locks in a rank-only copy of whichever of the 4 diamond cells best improves the player's rank hand, the moment the diamond reveal completes. This choice freezes permanently \u2014 it never re-evaluates once the center card turns, so it can be "caught out" by a center reveal it couldn't see coming.`
  },
  ["jeweler" /* JEWELER */]: {
    type: "jeweler" /* JEWELER */,
    name: "Jeweler",
    sign: "positive" /* POSITIVE */,
    tier: 2,
    description: "Copies the jewel of the player's other hole card. Real rank and suit retained. Resolves instantly at deal."
  },
  ["joker" /* JOKER */]: {
    type: "joker" /* JOKER */,
    name: "Joker",
    sign: "positive" /* POSITIVE */,
    tier: 1,
    description: "Suit stays undetermined until showdown, then locks to whichever suit makes the hand strongest. Rank and jewel are fixed and real."
  },
  ["soothsayer" /* SOOTHSAYER */]: {
    type: "soothsayer" /* SOOTHSAYER */,
    name: "Soothsayer",
    sign: "positive" /* POSITIVE */,
    tier: 2,
    description: `Same trigger as Oracle (right after the diamond reveal). Shows the holder the suit and jewel of every other player's hole cards (not their rank). Special cards show as "?".`
  },
  ["spy" /* SPY */]: {
    type: "spy" /* SPY */,
    name: "Spy",
    sign: "positive" /* POSITIVE */,
    tier: 1,
    description: "Same trigger as Oracle (right after the diamond reveal). Reveals which special card each other player holds \u2014 but none of any card's values."
  },
  ["omnipotent" /* OMNIPOTENT */]: {
    type: "omnipotent" /* OMNIPOTENT */,
    name: "Omnipotent",
    sign: "positive" /* POSITIVE */,
    tier: 3,
    description: `Same trigger as Oracle (right after the diamond reveal). Shows the holder every other player's hole cards in full \u2014 rank, suit and jewel. Special cards show as "?".`
  },
  ["ghost" /* GHOST */]: {
    type: "ghost" /* GHOST */,
    name: "Ghost",
    sign: "negative" /* NEGATIVE */,
    tier: 2,
    description: "Suit and jewel are real. Rank counts as nothing \u2014 permanent dead weight for pairs/trips/straights/etc."
  },
  ["orphan" /* ORPHAN */]: {
    type: "orphan" /* ORPHAN */,
    name: "Orphan",
    sign: "negative" /* NEGATIVE */,
    tier: 1,
    description: "Rank and jewel are real. Suit counts as no suit \u2014 dead weight for flush purposes."
  },
  ["void" /* VOID */]: {
    type: "void" /* VOID */,
    name: "Void",
    sign: "negative" /* NEGATIVE */,
    tier: 3,
    description: "Rank and suit are real. Jewel counts as no jewel \u2014 dead weight for jewel-hand purposes (caps the jewel ceiling, e.g. rules out Five of a Jewel for that hand)."
  },
  ["crossed" /* CROSSED */]: {
    type: "crossed" /* CROSSED */,
    name: "Crossed",
    sign: "negative" /* NEGATIVE */,
    tier: 2,
    description: "Removes both diagonals from the player's searchable line-set, leaving only the 6 straight rows/columns. No L-shapes added (the direct opposite of Anchor)."
  },
  ["limbo" /* LIMBO */]: {
    type: "limbo" /* LIMBO */,
    name: "Limbo",
    sign: "negative" /* NEGATIVE */,
    tier: 3,
    description: "Becomes the lowest-value card the matrix does not have, once the center card turns: the lowest rank not on the matrix (so it can never pair with it), with the suit and the jewel that appear on the matrix least."
  },
  ["snare" /* SNARE */]: {
    type: "snare" /* SNARE */,
    name: "Snare",
    sign: "negative" /* NEGATIVE */,
    tier: 3,
    description: "Finds whichever line gives the player's best rank result, removes that specific line, forces recalculation of best rank result from what's left."
  },
  ["flawed" /* FLAWED */]: {
    type: "flawed" /* FLAWED */,
    name: "Flawed",
    sign: "negative" /* NEGATIVE */,
    tier: 2,
    description: "Same as Snare, for the jewel axis: finds the best jewel-line, removes it, forces recalculation."
  },
  ["fray" /* FRAY */]: {
    type: "fray" /* FRAY */,
    name: "Fray",
    sign: "negative" /* NEGATIVE */,
    tier: 1,
    description: "Same as Snare/Flawed, for the suit axis: finds the best suit/flush-potential line, removes it, forces recalculation."
  },
  ["prank" /* PRANK */]: {
    type: "prank" /* PRANK */,
    name: "Prank",
    sign: "negative" /* NEGATIVE */,
    tier: 2,
    description: "A real, fixed card that counts fully all hand \u2014 but its rank is hidden from you (and only you) until showdown. Suit and jewel are shown."
  },
  ["blind" /* BLIND */]: {
    type: "blind" /* BLIND */,
    name: "Blind",
    sign: "negative" /* NEGATIVE */,
    tier: 2,
    description: "A real, fixed card that counts fully all hand \u2014 but its suit is hidden from you (and only you) until showdown. Rank and jewel are shown."
  },
  ["buried" /* BURIED */]: {
    type: "buried" /* BURIED */,
    name: "Buried",
    sign: "negative" /* NEGATIVE */,
    tier: 2,
    description: "A real, fixed card that counts fully all hand \u2014 but its jewel is hidden from you (and only you) until showdown. Rank and suit are shown."
  },
  ["origami" /* ORIGAMI */]: {
    type: "origami" /* ORIGAMI */,
    name: "Origami",
    sign: "negative" /* NEGATIVE */,
    tier: 2,
    description: "You can't fold this hand \u2014 every betting round you must check/call or raise."
  },
  ["hellraiser" /* HELLRAISER */]: {
    type: "hellraiser" /* HELLRAISER */,
    name: "Hellraiser",
    sign: "negative" /* NEGATIVE */,
    tier: 2,
    description: "You can't check or call this hand \u2014 every betting round you must fold or raise. Going all-in always counts as a raise."
  },
  ["commentator" /* COMMENTATOR */]: {
    type: "commentator" /* COMMENTATOR */,
    // Shown as Shepherd (it keeps you with the flock: follow, never lead); the
    // type keeps its first name, so stored and deployed data is unaffected.
    name: "Shepherd",
    sign: "negative" /* NEGATIVE */,
    tier: 1,
    description: "You can't raise this hand \u2014 every betting round you must fold or check/call."
  }
};
var SpecialCardTypeSchema = z.nativeEnum(SpecialCardType);
var SpecialCardSignSchema = z.nativeEnum(SpecialCardSign);

// src/types/card.ts
var Suit = /* @__PURE__ */ ((Suit2) => {
  Suit2["HEARTS"] = "hearts";
  Suit2["DIAMONDS"] = "diamonds";
  Suit2["CLUBS"] = "clubs";
  Suit2["SPADES"] = "spades";
  return Suit2;
})(Suit || {});
var Rank = /* @__PURE__ */ ((Rank2) => {
  Rank2["TWO"] = "2";
  Rank2["THREE"] = "3";
  Rank2["FOUR"] = "4";
  Rank2["FIVE"] = "5";
  Rank2["SIX"] = "6";
  Rank2["SEVEN"] = "7";
  Rank2["EIGHT"] = "8";
  Rank2["NINE"] = "9";
  Rank2["TEN"] = "10";
  Rank2["JACK"] = "J";
  Rank2["QUEEN"] = "Q";
  Rank2["KING"] = "K";
  Rank2["ACE"] = "A";
  return Rank2;
})(Rank || {});
var Jewel = /* @__PURE__ */ ((Jewel2) => {
  Jewel2["RUBY"] = "ruby";
  Jewel2["EMERALD"] = "emerald";
  Jewel2["TOPAZ"] = "topaz";
  Jewel2["ONYX"] = "onyx";
  return Jewel2;
})(Jewel || {});
var SuitSchema = z2.nativeEnum(Suit);
var RankSchema = z2.nativeEnum(Rank);
var JewelSchema = z2.nativeEnum(Jewel);
var CardSchema = z2.object({
  suit: SuitSchema,
  rank: RankSchema,
  jewel: JewelSchema,
  special: SpecialCardTypeSchema.optional(),
  concealed: z2.enum(["rank", "suit", "jewel"]).optional(),
  id: z2.string().min(1)
});
var DeckSchema = z2.array(CardSchema).length(52);

// src/types/player.ts
import { z as z3 } from "zod";
var ActionType = /* @__PURE__ */ ((ActionType2) => {
  ActionType2["FOLD"] = "fold";
  ActionType2["CHECK"] = "check";
  ActionType2["CALL"] = "call";
  ActionType2["RAISE"] = "raise";
  ActionType2["BET"] = "bet";
  ActionType2["ALL_IN"] = "all_in";
  return ActionType2;
})(ActionType || {});
var PlayerStatus = /* @__PURE__ */ ((PlayerStatus2) => {
  PlayerStatus2["WAITING"] = "waiting";
  PlayerStatus2["ACTIVE"] = "active";
  PlayerStatus2["FOLDED"] = "folded";
  PlayerStatus2["ALL_IN"] = "all_in";
  PlayerStatus2["DISCONNECTED"] = "disconnected";
  return PlayerStatus2;
})(PlayerStatus || {});
var ActionTypeSchema = z3.nativeEnum(ActionType);
var PlayerStatusSchema = z3.nativeEnum(PlayerStatus);
var PlayerSchema = z3.object({
  id: z3.string().min(1),
  name: z3.string().min(1).max(50),
  chips: z3.number().int().min(0),
  position: z3.number().int().min(1).max(10),
  cards: z3.array(CardSchema).max(2),
  status: PlayerStatusSchema,
  currentBet: z3.number().int().min(0),
  totalBet: z3.number().int().min(0),
  avatar: z3.string().url().optional(),
  isConnected: z3.boolean()
});
var PlayerActionSchema = z3.object({
  playerId: z3.string().min(1),
  type: ActionTypeSchema,
  amount: z3.number().int().min(0).optional(),
  timestamp: z3.number().int().positive()
});
var PlayerStatsSchema = z3.object({
  handsPlayed: z3.number().int().min(0),
  handsWon: z3.number().int().min(0),
  totalWinnings: z3.number().int(),
  biggestPot: z3.number().int().min(0)
});

// src/types/game.ts
var GamePhase = /* @__PURE__ */ ((GamePhase2) => {
  GamePhase2["ANTE"] = "ante";
  GamePhase2["PRE_FLOP"] = "pre_flop";
  GamePhase2["ROUND_1"] = "round_1";
  GamePhase2["ROUND_2"] = "round_2";
  GamePhase2["ROUND_3"] = "round_3";
  GamePhase2["SHOWDOWN"] = "showdown";
  GamePhase2["ENDED"] = "ended";
  return GamePhase2;
})(GamePhase || {});
var HandRanking = /* @__PURE__ */ ((HandRanking2) => {
  HandRanking2[HandRanking2["HIGH_CARD"] = 0] = "HIGH_CARD";
  HandRanking2[HandRanking2["PAIR"] = 1] = "PAIR";
  HandRanking2[HandRanking2["TWO_PAIR"] = 2] = "TWO_PAIR";
  HandRanking2[HandRanking2["THREE_OF_A_KIND"] = 3] = "THREE_OF_A_KIND";
  HandRanking2[HandRanking2["STRAIGHT"] = 4] = "STRAIGHT";
  HandRanking2[HandRanking2["FLUSH"] = 5] = "FLUSH";
  HandRanking2[HandRanking2["FULL_HOUSE"] = 6] = "FULL_HOUSE";
  HandRanking2[HandRanking2["FOUR_OF_A_KIND"] = 7] = "FOUR_OF_A_KIND";
  HandRanking2[HandRanking2["STRAIGHT_FLUSH"] = 8] = "STRAIGHT_FLUSH";
  HandRanking2[HandRanking2["ROYAL_FLUSH"] = 9] = "ROYAL_FLUSH";
  return HandRanking2;
})(HandRanking || {});
var JewelHandRanking = /* @__PURE__ */ ((JewelHandRanking2) => {
  JewelHandRanking2[JewelHandRanking2["JEWEL_HIGH"] = 0] = "JEWEL_HIGH";
  JewelHandRanking2[JewelHandRanking2["JEWEL_PAIR"] = 1] = "JEWEL_PAIR";
  JewelHandRanking2[JewelHandRanking2["JEWEL_TWO_PAIR"] = 2] = "JEWEL_TWO_PAIR";
  JewelHandRanking2[JewelHandRanking2["JEWEL_TRIPS"] = 3] = "JEWEL_TRIPS";
  JewelHandRanking2[JewelHandRanking2["JEWEL_FULL_HOUSE"] = 4] = "JEWEL_FULL_HOUSE";
  JewelHandRanking2[JewelHandRanking2["FOUR_OF_A_JEWEL"] = 5] = "FOUR_OF_A_JEWEL";
  JewelHandRanking2[JewelHandRanking2["FIVE_OF_A_JEWEL"] = 6] = "FIVE_OF_A_JEWEL";
  return JewelHandRanking2;
})(JewelHandRanking || {});
var GamePhaseSchema = z4.nativeEnum(GamePhase);
var GridPositionSchema = z4.union([
  z4.literal(1),
  z4.literal(2),
  z4.literal(3),
  z4.literal(4),
  z4.literal(5),
  z4.literal(6),
  z4.literal(7),
  z4.literal(8),
  z4.literal(9)
]);
var HandRankingSchema = z4.nativeEnum(HandRanking);
var JewelHandRankingSchema = z4.nativeEnum(JewelHandRanking);
var GridCardSchema = z4.object({
  card: CardSchema,
  position: GridPositionSchema,
  revealed: z4.boolean(),
  privatelyVisibleTo: z4.array(z4.string().min(1)).optional()
});
var HandEvaluationSchema = z4.object({
  ranking: HandRankingSchema,
  name: z4.string(),
  description: z4.string().optional(),
  value: z4.number().int().min(0),
  cards: z4.array(CardSchema).length(5)
});
var JewelHandEvaluationSchema = z4.object({
  ranking: JewelHandRankingSchema,
  name: z4.string(),
  description: z4.string().optional(),
  value: z4.number().int().min(0),
  cards: z4.array(CardSchema).length(5)
});
var GameConfigSchema = z4.object({
  maxPlayers: z4.literal(10),
  minPlayers: z4.number().int().min(2).max(10),
  anteAmount: z4.number().int().positive(),
  timebank: z4.number().int().positive(),
  useQRNG: z4.boolean(),
  specialCardEffects: z4.boolean().optional()
});
var WinnerInfoSchema = z4.object({
  playerId: z4.string().min(1),
  amount: z4.number().int().positive(),
  handEvaluation: HandEvaluationSchema
});
var JewelWinnerInfoSchema = z4.object({
  playerId: z4.string().min(1),
  amount: z4.number().int().positive(),
  jewelHandEvaluation: JewelHandEvaluationSchema
});
var GameTableSchema = z4.object({
  id: z4.string().min(1),
  name: z4.string().min(1),
  config: GameConfigSchema,
  players: z4.array(PlayerSchema).max(10),
  phase: GamePhaseSchema,
  dealerPosition: z4.number().int().min(1).max(10),
  currentPlayerIndex: z4.number().int().min(0),
  gridCards: z4.array(GridCardSchema).length(9),
  pot: z4.number().int().min(0),
  currentBet: z4.number().int().min(0),
  minRaise: z4.number().int().min(0),
  deck: z4.array(CardSchema),
  winners: z4.array(WinnerInfoSchema).optional(),
  jewelWinners: z4.array(JewelWinnerInfoSchema).optional(),
  handNumber: z4.number().int().min(0),
  createdAt: z4.number().int().positive(),
  updatedAt: z4.number().int().positive()
});
var GameHistorySchema = z4.object({
  tableId: z4.string().min(1),
  handNumber: z4.number().int().min(0),
  players: z4.array(PlayerSchema),
  actions: z4.array(PlayerActionSchema),
  gridCards: z4.array(GridCardSchema).length(9),
  winners: z4.array(WinnerInfoSchema),
  pot: z4.number().int().min(0),
  timestamp: z4.number().int().positive(),
  qrngUsed: z4.boolean()
});

// src/constants/game.ts
var DEFAULT_GAME_CONFIG = {
  maxPlayers: 10,
  minPlayers: 2,
  anteAmount: 10,
  timebank: 30,
  useQRNG: true
};
var HAND_RANKING_NAMES = {
  [0 /* HIGH_CARD */]: "High Card",
  [1 /* PAIR */]: "Pair",
  [2 /* TWO_PAIR */]: "Two Pair",
  [3 /* THREE_OF_A_KIND */]: "Three of a Kind",
  [4 /* STRAIGHT */]: "Straight",
  [5 /* FLUSH */]: "Flush",
  [6 /* FULL_HOUSE */]: "Full House",
  [7 /* FOUR_OF_A_KIND */]: "Four of a Kind",
  [8 /* STRAIGHT_FLUSH */]: "Straight Flush",
  [9 /* ROYAL_FLUSH */]: "Royal Flush"
};
var JEWEL_HAND_RANKING_NAMES = {
  [0 /* JEWEL_HIGH */]: "No Jewel Match",
  [1 /* JEWEL_PAIR */]: "Jewel Pair",
  [2 /* JEWEL_TWO_PAIR */]: "Jewel Two Pair",
  [3 /* JEWEL_TRIPS */]: "Jewel Three of a Kind",
  [4 /* JEWEL_FULL_HOUSE */]: "Jewel Full House",
  [5 /* FOUR_OF_A_JEWEL */]: "Four of a Jewel",
  [6 /* FIVE_OF_A_JEWEL */]: "Five of a Jewel"
};
var HAND_RANKING_VALUES = {
  [0 /* HIGH_CARD */]: 0,
  [1 /* PAIR */]: 1,
  [2 /* TWO_PAIR */]: 2,
  [3 /* THREE_OF_A_KIND */]: 3,
  [4 /* STRAIGHT */]: 4,
  [5 /* FLUSH */]: 5,
  [6 /* FULL_HOUSE */]: 6,
  [7 /* FOUR_OF_A_KIND */]: 7,
  [8 /* STRAIGHT_FLUSH */]: 8,
  [9 /* ROYAL_FLUSH */]: 9
};
var TIMEOUTS = {
  /** Maximum time for player action (milliseconds) */
  ACTION_TIMEOUT: 3e4,
  // 30 seconds
  /** Delay before starting a new hand */
  START_HAND_DELAY: 3e3,
  // 3 seconds
  /** Delay between dealing individual cards */
  DEAL_CARD_DELAY: 300,
  // 300ms between cards
  /** Delay between revealing grid cards */
  REVEAL_CARD_DELAY: 500,
  // 500ms between reveals
  /** Delay before advancing to next betting round */
  ROUND_TRANSITION_DELAY: 2e3,
  // 2 seconds
  /** Delay during showdown to display results */
  SHOWDOWN_DELAY: 5e3
  // 5 seconds
};
var ANIMATIONS = {
  /** Card flip animation duration */
  CARD_FLIP: 400,
  /** Chip movement to pot */
  CHIP_MOVE: 800,
  /** Player highlight */
  PLAYER_HIGHLIGHT: 200,
  /** Grid card reveal */
  GRID_REVEAL: 600
};

// src/constants/poker.ts
var SUITS = ["hearts" /* HEARTS */, "diamonds" /* DIAMONDS */, "clubs" /* CLUBS */, "spades" /* SPADES */];
var JEWELS = ["ruby" /* RUBY */, "emerald" /* EMERALD */, "topaz" /* TOPAZ */, "onyx" /* ONYX */];
var RANKS = [
  "2" /* TWO */,
  "3" /* THREE */,
  "4" /* FOUR */,
  "5" /* FIVE */,
  "6" /* SIX */,
  "7" /* SEVEN */,
  "8" /* EIGHT */,
  "9" /* NINE */,
  "10" /* TEN */,
  "J" /* JACK */,
  "Q" /* QUEEN */,
  "K" /* KING */,
  "A" /* ACE */
];
var RANK_VALUES = {
  ["2" /* TWO */]: 2,
  ["3" /* THREE */]: 3,
  ["4" /* FOUR */]: 4,
  ["5" /* FIVE */]: 5,
  ["6" /* SIX */]: 6,
  ["7" /* SEVEN */]: 7,
  ["8" /* EIGHT */]: 8,
  ["9" /* NINE */]: 9,
  ["10" /* TEN */]: 10,
  ["J" /* JACK */]: 11,
  ["Q" /* QUEEN */]: 12,
  ["K" /* KING */]: 13,
  ["A" /* ACE */]: 14
};
var PLAYERS_PER_TABLE = 10;
var HOLE_CARDS = 2;
var COMMUNITY_CARDS = 9;
var HAND_SIZE = 5;
var GRID_POSITIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9];
var GRID_CORNERS = [1, 3, 7, 9];
var GRID_DIAMOND = [2, 4, 6, 8];
var GRID_CENTER = [5];
var GRID_REVEAL_PHASES = {
  /** Round 1: Reveal corners */
  ROUND_1: GRID_CORNERS,
  /** Round 2: Reveal diamond/edges */
  ROUND_2: GRID_DIAMOND,
  /** Round 3: Reveal center */
  ROUND_3: GRID_CENTER
};
var GRID_LINES = [
  [1, 2, 3],
  [4, 5, 6],
  [7, 8, 9],
  [1, 4, 7],
  [2, 5, 8],
  [3, 6, 9],
  [1, 5, 9],
  [3, 5, 7]
];
var isPositionInPhase = (position, phase) => {
  return GRID_REVEAL_PHASES[phase].includes(position);
};
var getGridRow = (position) => {
  if (position <= 3) return 1;
  if (position <= 6) return 2;
  return 3;
};
var getGridColumn = (position) => {
  const col = (position - 1) % 3 + 1;
  return col;
};
var getGridCoordinates = (position) => {
  return [getGridRow(position), getGridColumn(position)];
};
var GRID_LINES_STRAIGHT = GRID_LINES.slice(0, 6);
var GRID_LINES_SNAKE = (() => {
  const orthogonalNeighbors = (position) => {
    const [row, col] = getGridCoordinates(position);
    const neighbors = [];
    for (const [dRow, dCol] of [
      [-1, 0],
      [1, 0],
      [0, -1],
      [0, 1]
    ]) {
      const r = row + dRow;
      const c = col + dCol;
      if (r >= 1 && r <= 3 && c >= 1 && c <= 3) {
        neighbors.push((r - 1) * 3 + c);
      }
    }
    return neighbors;
  };
  const lines = [];
  for (const middle of GRID_POSITIONS) {
    const neighbors = orthogonalNeighbors(middle);
    for (let i = 0; i < neighbors.length; i++) {
      for (let j = i + 1; j < neighbors.length; j++) {
        lines.push([neighbors[i], middle, neighbors[j]].sort((a, b) => a - b));
      }
    }
  }
  return lines;
})();
var GRID_LINES_COMPLETE_BEFORE_CENTER = GRID_LINES.filter(
  (line) => !line.includes(5)
);

// src/constants/special-cards.ts
var SPECIAL_CARD_DEAL_CHANCE = 1 / 6;
var SPECIAL_CARD_TIER_WEIGHTS = {
  1: 3,
  2: 2,
  3: 1
};
var SPECIAL_CARD_TOTAL_TIER_WEIGHT = Object.values(SPECIAL_CARD_TIER_WEIGHTS).reduce(
  (sum, w) => sum + w,
  0
);
var SPECIAL_CARD_TIERS = { 1: [], 2: [], 3: [] };
for (const info of Object.values(SPECIAL_CARD_INFO)) {
  SPECIAL_CARD_TIERS[info.tier].push(info.type);
}
var SPECIAL_CARD_TOTAL_CARD_WEIGHT = [1, 2, 3].reduce(
  (sum, tier) => sum + SPECIAL_CARD_TIERS[tier].length * SPECIAL_CARD_TIER_WEIGHTS[tier],
  0
);

// src/engine/secureRandom.ts
function getCrypto() {
  const c = globalThis.crypto;
  if (!c?.getRandomValues) {
    throw new Error("Secure random source unavailable (globalThis.crypto.getRandomValues)");
  }
  return c;
}
function secureRandomInt(maxExclusive) {
  if (!Number.isInteger(maxExclusive) || maxExclusive <= 0 || maxExclusive > 2 ** 32) {
    throw new Error(`secureRandomInt: invalid range ${maxExclusive}`);
  }
  const limit = 2 ** 32 - 2 ** 32 % maxExclusive;
  const buffer = new Uint32Array(1);
  const crypto = getCrypto();
  for (; ; ) {
    crypto.getRandomValues(buffer);
    if (buffer[0] < limit) return buffer[0] % maxExclusive;
  }
}
function secureRandom() {
  const buffer = new Uint32Array(2);
  getCrypto().getRandomValues(buffer);
  return ((buffer[0] >>> 6) * 2 ** 27 + (buffer[1] >>> 5)) / 2 ** 53;
}
var ByteIndexReader = class {
  constructor(bytes) {
    this.bytes = bytes;
    this.position = 0;
    /** How many indexes had to draw on the fallback source. */
    this.fallbackBytesUsed = 0;
  }
  /** A uniformly random integer in [0, maxExclusive), maxExclusive <= 256. */
  nextIndex(maxExclusive) {
    if (!Number.isInteger(maxExclusive) || maxExclusive <= 0 || maxExclusive > 256) {
      throw new Error(`ByteIndexReader: invalid range ${maxExclusive}`);
    }
    const limit = 256 - 256 % maxExclusive;
    for (; ; ) {
      const byte = this.nextByte();
      if (byte < limit) return byte % maxExclusive;
    }
  }
  nextByte() {
    if (this.position < this.bytes.length) {
      return this.bytes[this.position++] & 255;
    }
    this.fallbackBytesUsed++;
    return secureRandomInt(256);
  }
};

// src/engine/Deck.ts
function balancedJewels(count) {
  if (count % JEWELS.length !== 0) {
    throw new Error(`Cannot split ${count} cards evenly across ${JEWELS.length} jewels`);
  }
  const jewels = Array.from({ length: count }, (_, i) => JEWELS[i % JEWELS.length]);
  for (let i = jewels.length - 1; i > 0; i--) {
    const j = secureRandomInt(i + 1);
    [jewels[i], jewels[j]] = [jewels[j], jewels[i]];
  }
  return jewels;
}
var Deck = class {
  constructor() {
    this.cards = [];
    this.dealtCards = [];
    this.qrngUsed = false;
  }
  /**
   * Initialize a fresh 52-card deck
   */
  initialize() {
    this.cards = this.createDeck();
    this.dealtCards = [];
    this.qrngUsed = false;
  }
  /**
   * Create a standard 52-card deck
   * @returns Array of 52 cards
   */
  createDeck() {
    const deck = [];
    const jewels = balancedJewels(SUITS.length * RANKS.length);
    let cardId = 0;
    for (const suit of SUITS) {
      for (const rank of RANKS) {
        deck.push({
          suit,
          rank,
          // Jewel is a second suit: exactly 13 of each, spread across the
          // deck at random (see balancedJewels). The deck is rebuilt every
          // hand, so which cards carry which jewel changes every hand.
          jewel: jewels[cardId],
          id: `${suit}-${rank}-${cardId++}`
        });
      }
    }
    return deck;
  }
  /**
   * Shuffle deck using quantum random number generator
   * @param qrngBytes - Array of random bytes from QRNG (min 52 bytes; a
   * few more is better — unbiased index selection occasionally discards a
   * byte, and any shortfall is made up from the secure local source)
   * @throws Error if insufficient random bytes provided
   */
  shuffleWithQRNG(qrngBytes) {
    if (qrngBytes.length < 52) {
      throw new Error("Insufficient QRNG bytes: need at least 52 bytes");
    }
    const reader = new ByteIndexReader(qrngBytes);
    this.fisherYates((n) => reader.nextIndex(n));
    this.qrngUsed = true;
  }
  /**
   * Shuffle deck using the cryptographically secure local source (Web
   * Crypto) — the fallback whenever no QRNG bytes are supplied.
   */
  shuffleWithCSPRNG() {
    this.fisherYates(secureRandomInt);
    this.qrngUsed = false;
  }
  /**
   * Fisher-Yates shuffle. `randomIndex(n)` must return a uniformly random
   * integer in [0, n) — with that, every ordering of the deck is equally
   * likely.
   */
  fisherYates(randomIndex) {
    const deck = [...this.cards];
    for (let i = deck.length - 1; i > 0; i--) {
      const j = randomIndex(i + 1);
      [deck[i], deck[j]] = [deck[j], deck[i]];
    }
    this.cards = deck;
  }
  /**
   * Deal a single card from the top of the deck
   * @returns The dealt card
   * @throws Error if deck is empty
   */
  dealCard() {
    const card = this.cards.pop();
    if (!card) {
      throw new Error("Deck is empty - cannot deal card");
    }
    this.dealtCards.push(card);
    return card;
  }
  /**
   * Deal multiple cards
   * @param count - Number of cards to deal
   * @returns Array of dealt cards
   * @throws Error if not enough cards remaining
   */
  dealCards(count) {
    if (count > this.cards.length) {
      throw new Error(
        `Not enough cards in deck: requested ${count}, available ${this.cards.length}`
      );
    }
    const dealt = [];
    for (let i = 0; i < count; i++) {
      dealt.push(this.dealCard());
    }
    return dealt;
  }
  /**
   * Get number of cards remaining in deck
   */
  getRemainingCount() {
    return this.cards.length;
  }
  /**
   * Get number of cards that have been dealt
   */
  getDealtCount() {
    return this.dealtCards.length;
  }
  /**
   * Check if QRNG was used for shuffling
   */
  wasQRNGUsed() {
    return this.qrngUsed;
  }
  /**
   * Get all remaining cards (for debugging/testing)
   */
  getRemaining() {
    return [...this.cards];
  }
  /**
   * Get all dealt cards (for debugging/testing)
   */
  getDealt() {
    return [...this.dealtCards];
  }
  /**
   * Reset deck to initial state
   */
  reset() {
    this.initialize();
  }
  /**
   * Burn a card (remove from play without dealing)
   * Common in poker to prevent cheating
   */
  burnCard() {
    if (this.cards.length === 0) return null;
    const card = this.cards.pop();
    if (card) {
      this.dealtCards.push(card);
    }
    return card || null;
  }
};
function createShuffledDeck(qrngBytes) {
  const deck = new Deck();
  deck.initialize();
  if (qrngBytes && qrngBytes.length >= 52) {
    deck.shuffleWithQRNG(qrngBytes);
  } else {
    deck.shuffleWithCSPRNG();
  }
  return deck;
}

// src/engine/HandEvaluator.ts
var RANK_WORD = {
  ["2" /* TWO */]: "Two",
  ["3" /* THREE */]: "Three",
  ["4" /* FOUR */]: "Four",
  ["5" /* FIVE */]: "Five",
  ["6" /* SIX */]: "Six",
  ["7" /* SEVEN */]: "Seven",
  ["8" /* EIGHT */]: "Eight",
  ["9" /* NINE */]: "Nine",
  ["10" /* TEN */]: "Ten",
  ["J" /* JACK */]: "Jack",
  ["Q" /* QUEEN */]: "Queen",
  ["K" /* KING */]: "King",
  ["A" /* ACE */]: "Ace"
};
var RANK_PLURAL = {
  ["2" /* TWO */]: "Twos",
  ["3" /* THREE */]: "Threes",
  ["4" /* FOUR */]: "Fours",
  ["5" /* FIVE */]: "Fives",
  ["6" /* SIX */]: "Sixes",
  ["7" /* SEVEN */]: "Sevens",
  ["8" /* EIGHT */]: "Eights",
  ["9" /* NINE */]: "Nines",
  ["10" /* TEN */]: "Tens",
  ["J" /* JACK */]: "Jacks",
  ["Q" /* QUEEN */]: "Queens",
  ["K" /* KING */]: "Kings",
  ["A" /* ACE */]: "Aces"
};
var RANK_SHORT = {
  ["2" /* TWO */]: "2",
  ["3" /* THREE */]: "3",
  ["4" /* FOUR */]: "4",
  ["5" /* FIVE */]: "5",
  ["6" /* SIX */]: "6",
  ["7" /* SEVEN */]: "7",
  ["8" /* EIGHT */]: "8",
  ["9" /* NINE */]: "9",
  ["10" /* TEN */]: "10",
  ["J" /* JACK */]: "J",
  ["Q" /* QUEEN */]: "Q",
  ["K" /* KING */]: "K",
  ["A" /* ACE */]: "A"
};
var rankIsDead = (card) => card.special === "ghost" /* GHOST */ || card.concealed === "rank";
var suitIsDead = (card) => card.special === "orphan" /* ORPHAN */ || card.concealed === "suit";
var jewelIsDead = (card) => card.special === "void" /* VOID */ || card.concealed === "jewel";
var HandEvaluator = class {
  /**
   * Evaluate the best 5-card poker hand from available cards
   * @param cards - Array of cards (typically 7-11: 2 hole + up to 9 community)
   * @returns Best possible hand evaluation
   */
  static evaluateBestHand(cards) {
    if (cards.length < HAND_SIZE) {
      throw new Error(`Need at least ${HAND_SIZE} cards to evaluate a hand`);
    }
    if (cards.length === HAND_SIZE) {
      return this.evaluateHand(cards);
    }
    const combinations = this.getCombinations(cards, HAND_SIZE);
    let bestHand = null;
    for (const combo of combinations) {
      const hand = this.evaluateHand(combo);
      if (!bestHand || this.compareHands(hand, bestHand) > 0) {
        bestHand = hand;
      }
    }
    if (!bestHand) {
      throw new Error("Failed to evaluate hand");
    }
    return bestHand;
  }
  /**
   * Evaluate a player's best hand under PokerCubed's actual grid rule: 2 hole
   * cards plus the best 3-card *line* through the 3x3 grid (one of the 8
   * lines in GRID_LINES — 3 rows, 3 columns, 2 diagonals), not just any 5 of
   * the 11 cards. This is what makes the grid's spatial layout matter,
   * rather than the 9 community cards just being a pool identical to a
   * normal 9-card board.
   * @param holeCards - The player's 2 hole cards
   * @param gridCards - All 9 grid cards (must all be revealed by showdown)
   * @param lines - The line-set to search (defaults to the standard 8; a
   * player holding Anchor/Crossed searches a different set — see
   * poker-app-spec.md Section 4.3/4.4)
   * @returns The best hand achievable across all lines, plus which line it came from
   */
  static evaluateBestGridHand(holeCards, gridCards, lines = GRID_LINES) {
    const cardAtPosition = /* @__PURE__ */ new Map();
    for (const gridCard of gridCards) {
      cardAtPosition.set(gridCard.position, gridCard.card);
    }
    let best = null;
    for (const line of lines) {
      const lineCards = line.map((position) => cardAtPosition.get(position));
      if (lineCards.some((card) => !card)) {
        continue;
      }
      const resolvedHoleCards = this.resolveJoker(
        this.resolveHighflyerAndLimbo(holeCards, lineCards),
        lineCards
      );
      const hand = this.evaluateHand([...resolvedHoleCards, ...lineCards]);
      if (!best || this.compareHands(hand, best) > 0) {
        best = { ...hand, winningLine: [...line] };
      }
    }
    if (!best) {
      throw new Error("No complete grid line available to evaluate \u2014 has the grid been fully revealed?");
    }
    return best;
  }
  /**
   * Highflyer (poker-app-spec.md Section 4.3/4.4 step 4) becomes a copy of
   * the highest-rank card among the *3 grid cells of the specific line being
   * evaluated* — never the hole cards — keeping its own suit/jewel. (Limbo
   * used to be its lowest-rank mirror; it now resolves once, by mutation,
   * when the center reveals — see resolveLimbo.) Their value genuinely depends on which line is being tried,
   * so unlike Numerology/Suitor/Thief/Impersonator (frozen once, by mutation,
   * at deal/reveal time) this can't be pre-baked — it's resolved fresh per
   * candidate line here. Grid cells never carry a `special` tag themselves
   * (specials are hole-card-only), so lineCards are always plain real cards.
   */
  static resolveHighflyerAndLimbo(holeCards, lineCards) {
    return holeCards.map((card) => {
      if (card.special === "highflyer" /* HIGHFLYER */) {
        return { ...card, rank: this.extremeRankCard(lineCards, "max").rank };
      }
      return card;
    });
  }
  /**
   * Joker (spec 4.3): "Suit stays undetermined until showdown, then locks to
   * whichever suit makes the hand strongest." The suit-axis sibling of
   * Chameleon — rank and jewel are fixed and real; only the suit is chosen
   * here, per candidate line, by trying all 4 suits and keeping the best
   * rank hand for that specific 5-card grouping.
   */
  static resolveJoker(holeCards, lineCards) {
    if (!holeCards.some((card) => card.special === "joker" /* JOKER */)) {
      return holeCards;
    }
    return holeCards.map((card) => {
      if (card.special !== "joker" /* JOKER */) {
        return card;
      }
      let bestSuit = card.suit;
      let bestHand = null;
      for (const candidateSuit of SUITS) {
        const candidateHoleCards = holeCards.map((c) => c === card ? { ...c, suit: candidateSuit } : c);
        const candidateHand = this.evaluateHand([...candidateHoleCards, ...lineCards]);
        if (!bestHand || this.compareHands(candidateHand, bestHand) > 0) {
          bestHand = candidateHand;
          bestSuit = candidateSuit;
        }
      }
      return { ...card, suit: bestSuit };
    });
  }
  static extremeRankCard(cards, mode) {
    let best = cards[0];
    for (const card of cards.slice(1)) {
      const better2 = mode === "max" ? RANK_VALUES[card.rank] > RANK_VALUES[best.rank] : RANK_VALUES[card.rank] < RANK_VALUES[best.rank];
      if (better2) best = card;
    }
    return best;
  }
  /**
   * Jewel-axis counterpart of evaluateBestGridHand: same line-constrained
   * search, scored on Card.jewel instead of Card.rank/suit (see
   * poker-app-spec.md Section 2 and Section 3's split-pot Hi/Lo format).
   * @param holeCards - The player's 2 hole cards
   * @param gridCards - All 9 grid cards (must all be revealed by showdown)
   * @param lines - The line-set to search (defaults to the standard 8)
   * @returns The best jewel hand achievable across all lines, plus which line it came from
   */
  static evaluateBestGridHandByJewel(holeCards, gridCards, lines = GRID_LINES) {
    const cardAtPosition = /* @__PURE__ */ new Map();
    for (const gridCard of gridCards) {
      cardAtPosition.set(gridCard.position, gridCard.card);
    }
    let best = null;
    for (const line of lines) {
      const lineCards = line.map((position) => cardAtPosition.get(position));
      if (lineCards.some((card) => !card)) {
        continue;
      }
      const resolvedHoleCards = this.resolveChameleon(holeCards, lineCards);
      const hand = this.evaluateJewelHand([...resolvedHoleCards, ...lineCards]);
      if (!best || this.compareJewelHands(hand, best) > 0) {
        best = { ...hand, winningLine: [...line] };
      }
    }
    if (!best) {
      throw new Error("No complete grid line available to evaluate \u2014 has the grid been fully revealed?");
    }
    return best;
  }
  /**
   * Chameleon (poker-app-spec.md Section 4.3/4.4 step 4): "Jewel stays
   * undetermined until showdown, then locks to whichever jewel makes the
   * hand strongest." Rank/suit are fixed and real — only the jewel is
   * resolved here, per candidate line, by trying all 4 jewels and keeping
   * whichever yields the best jewel hand for that specific 5-card grouping.
   */
  static resolveChameleon(holeCards, lineCards) {
    if (!holeCards.some((card) => card.special === "chameleon" /* CHAMELEON */)) {
      return holeCards;
    }
    return holeCards.map((card) => {
      if (card.special !== "chameleon" /* CHAMELEON */) {
        return card;
      }
      let bestJewel = card.jewel;
      let bestHand = null;
      for (const candidateJewel of JEWELS) {
        const candidateHoleCards = holeCards.map((c) => c === card ? { ...c, jewel: candidateJewel } : c);
        const candidateHand = this.evaluateJewelHand([...candidateHoleCards, ...lineCards]);
        if (!bestHand || this.compareJewelHands(candidateHand, bestHand) > 0) {
          bestHand = candidateHand;
          bestJewel = candidateJewel;
        }
      }
      return { ...card, jewel: bestJewel };
    });
  }
  /**
   * Snare (spec 4.3/4.4 step 5): finds the player's best rank-axis line,
   * removes it from their shape-set, and re-searches the rank axis over
   * what's left.
   */
  static evaluateBestGridHandWithSnare(holeCards, gridCards, lines = GRID_LINES) {
    const initial = this.evaluateBestGridHand(holeCards, gridCards, lines);
    return this.evaluateBestGridHand(holeCards, gridCards, this.excludeLine(lines, initial.winningLine));
  }
  /**
   * Flawed (spec 4.3/4.4 step 5): Snare's jewel-axis counterpart — finds the
   * best jewel-axis line, removes it, re-searches the jewel axis.
   */
  static evaluateBestGridHandByJewelWithFlawed(holeCards, gridCards, lines = GRID_LINES) {
    const initial = this.evaluateBestGridHandByJewel(holeCards, gridCards, lines);
    return this.evaluateBestGridHandByJewel(holeCards, gridCards, this.excludeLine(lines, initial.winningLine));
  }
  /**
   * Fray (spec 4.3/4.4 step 5): Snare/Flawed's counterpart "for the suit
   * axis" — removes whichever line best serves flush potential (highest
   * same-suit count among its 5 cards, an Orphan card in the mix always
   * scoring 0 there since it can never contribute to a flush), then
   * re-searches the *rank* axis over what's left — there's no separate
   * suit-axis pot (Section 3 is rank-vs-jewel only), so like Snare/Flawed
   * this ultimately feeds back into determining the rank-axis winner; it
   * just uses flush-potential rather than raw hand strength as its removal
   * criterion. (Not spelled out verbatim in the spec — documented here as
   * the implementation's resolution of "forces recalculation".)
   */
  static evaluateBestGridHandWithFray(holeCards, gridCards, lines = GRID_LINES) {
    const bestFlushLine = this.findBestFlushPotentialLine(holeCards, gridCards, lines);
    const remainingLines = bestFlushLine ? this.excludeLine(lines, bestFlushLine) : lines;
    return this.evaluateBestGridHand(holeCards, gridCards, remainingLines);
  }
  static excludeLine(lines, target) {
    const targetKey = [...target].sort((a, b) => a - b).join(",");
    return lines.filter((line) => [...line].sort((a, b) => a - b).join(",") !== targetKey);
  }
  static findBestFlushPotentialLine(holeCards, gridCards, lines) {
    const cardAtPosition = /* @__PURE__ */ new Map();
    for (const gridCard of gridCards) {
      cardAtPosition.set(gridCard.position, gridCard.card);
    }
    let bestLine = null;
    let bestScore = -1;
    for (const line of lines) {
      const lineCards = line.map((position) => cardAtPosition.get(position));
      if (lineCards.some((card) => !card)) continue;
      const score2 = this.maxSuitCount([...holeCards, ...lineCards]);
      if (score2 > bestScore) {
        bestScore = score2;
        bestLine = [...line];
      }
    }
    return bestLine;
  }
  /** Highest same-suit count among the cards, ignoring Orphan cards entirely; a Joker joins the biggest suit. */
  static maxSuitCount(cards) {
    const suitCounts = {};
    let jokers = 0;
    for (const card of cards) {
      if (suitIsDead(card)) continue;
      if (card.special === "joker" /* JOKER */) {
        jokers++;
        continue;
      }
      suitCounts[card.suit] = (suitCounts[card.suit] || 0) + 1;
    }
    const counts = Object.values(suitCounts);
    return (counts.length > 0 ? Math.max(...counts) : 0) + jokers;
  }
  /**
   * Evaluate a specific 5-card hand
   * @param cards - Exactly 5 cards
   * @returns Hand evaluation with ranking and value
   */
  static evaluateHand(cards) {
    if (cards.length !== HAND_SIZE) {
      throw new Error(`Hand must contain exactly ${HAND_SIZE} cards`);
    }
    const ranking = this.determineRanking(cards);
    const name = HAND_RANKING_NAMES[ranking];
    const value = this.calculateHandValue(cards, ranking);
    return {
      ranking,
      name,
      description: this.describeRankHand(cards, ranking),
      value,
      cards: [...cards]
    };
  }
  /**
   * Evaluate a specific 5-card hand on the jewel axis (sibling of evaluateHand)
   * @param cards - Exactly 5 cards
   * @returns Jewel hand evaluation with ranking and value
   */
  static evaluateJewelHand(cards) {
    if (cards.length !== HAND_SIZE) {
      throw new Error(`Jewel hand must contain exactly ${HAND_SIZE} cards`);
    }
    const ranking = this.determineJewelRanking(cards);
    const name = JEWEL_HAND_RANKING_NAMES[ranking];
    const value = this.calculateJewelHandValue(cards, ranking);
    return {
      ranking,
      name,
      description: this.describeJewelHand(cards, ranking),
      value,
      cards: [...cards]
    };
  }
  /**
   * Determine the poker hand ranking
   */
  static determineRanking(cards) {
    const isFlush = this.isFlush(cards);
    const isStraight = this.isStraight(cards);
    const rankCounts = this.getRankCounts(cards);
    const counts = Object.values(rankCounts).sort((a, b) => b - a);
    if (isFlush && isStraight && this.isRoyalStraight(cards)) {
      return 9 /* ROYAL_FLUSH */;
    }
    if (isFlush && isStraight) {
      return 8 /* STRAIGHT_FLUSH */;
    }
    if (counts[0] === 4) {
      return 7 /* FOUR_OF_A_KIND */;
    }
    if (counts[0] === 3 && counts[1] === 2) {
      return 6 /* FULL_HOUSE */;
    }
    if (isFlush) {
      return 5 /* FLUSH */;
    }
    if (isStraight) {
      return 4 /* STRAIGHT */;
    }
    if (counts[0] === 3) {
      return 3 /* THREE_OF_A_KIND */;
    }
    if (counts[0] === 2 && counts[1] === 2) {
      return 2 /* TWO_PAIR */;
    }
    if (counts[0] === 2) {
      return 1 /* PAIR */;
    }
    return 0 /* HIGH_CARD */;
  }
  /**
   * Determine the jewel hand ranking (sibling of determineRanking). With a
   * full 5 real jewels, pigeonhole (only 4 jewels) guarantees counts[0] >= 2
   * — but a Void card drops the counted total to 4, where no such guarantee
   * holds (4 cards can land on 4 distinct jewels), so JEWEL_HIGH covers that.
   */
  static determineJewelRanking(cards) {
    const jewelCounts = this.getJewelCounts(cards);
    const counts = Object.values(jewelCounts).sort((a, b) => b - a);
    if (!counts[0] || counts[0] < 2) {
      return 0 /* JEWEL_HIGH */;
    }
    if (counts[0] === 5) {
      return 6 /* FIVE_OF_A_JEWEL */;
    }
    if (counts[0] === 4) {
      return 5 /* FOUR_OF_A_JEWEL */;
    }
    if (counts[0] === 3 && counts[1] === 2) {
      return 4 /* JEWEL_FULL_HOUSE */;
    }
    if (counts[0] === 3) {
      return 3 /* JEWEL_TRIPS */;
    }
    if (counts[0] === 2 && counts[1] === 2) {
      return 2 /* JEWEL_TWO_PAIR */;
    }
    return 1 /* JEWEL_PAIR */;
  }
  /**
   * Check if all cards are the same suit. Orphan (spec 4.3: "Suit counts as
   * no suit — dead weight for flush purposes") can never be part of a flush
   * — its presence breaks one immediately, regardless of the other 4 suits.
   */
  static isFlush(cards) {
    if (cards.some(suitIsDead)) {
      return false;
    }
    const suit = cards[0].suit;
    return cards.every((card) => card.suit === suit);
  }
  /**
   * Check if cards form a straight. Ghost (spec 4.3: "Rank counts as
   * nothing — permanent dead weight for pairs/trips/straights/etc.") can
   * never complete a straight — only 4 real ranks are available with it present.
   */
  static isStraight(cards) {
    if (cards.some(rankIsDead)) {
      return false;
    }
    const values = cards.map((c) => RANK_VALUES[c.rank]).sort((a, b) => a - b);
    let isRegularStraight = true;
    for (let i = 1; i < values.length; i++) {
      if (values[i] !== values[i - 1] + 1) {
        isRegularStraight = false;
        break;
      }
    }
    if (isRegularStraight) return true;
    const isWheel = values[0] === 2 && values[1] === 3 && values[2] === 4 && values[3] === 5 && values[4] === 14;
    return isWheel;
  }
  /**
   * Check if straight is royal (10-J-Q-K-A)
   */
  static isRoyalStraight(cards) {
    const values = cards.map((c) => RANK_VALUES[c.rank]).sort((a, b) => a - b);
    return values[0] === 10 && values[1] === 11 && values[2] === 12 && values[3] === 13 && values[4] === 14;
  }
  /**
   * Get count of each rank. Ghost cards (spec 4.3) are excluded entirely —
   * their rank "counts as nothing," so they contribute to no group and are
   * never a kicker (calculateHandValue derives its groups from this map).
   */
  static getRankCounts(cards) {
    const counts = {};
    for (const card of cards) {
      if (rankIsDead(card)) continue;
      const rank = card.rank;
      counts[rank] = (counts[rank] || 0) + 1;
    }
    return counts;
  }
  /**
   * Get count of each jewel (sibling of getRankCounts). Void cards (spec
   * 4.3) are excluded entirely — their jewel "counts as no jewel."
   */
  static getJewelCounts(cards) {
    const counts = {};
    for (const card of cards) {
      if (jewelIsDead(card)) continue;
      const jewel = card.jewel;
      counts[jewel] = (counts[jewel] || 0) + 1;
    }
    return counts;
  }
  /**
   * The jewel groups in a hand in tie-break order: largest group first, then
   * by the group's highest card. Shared by the score (calculateJewelHandValue)
   * and the description (describeJewelHand).
   */
  static jewelGroups(cards) {
    const jewelCounts = this.getJewelCounts(cards);
    return Object.entries(jewelCounts).map(([jewel, count]) => {
      const jewelCards = cards.filter((c) => c.jewel === jewel && !jewelIsDead(c));
      const top = jewelCards.reduce((best, c) => RANK_VALUES[c.rank] > RANK_VALUES[best.rank] ? c : best);
      return { jewel, count, maxRankValue: RANK_VALUES[top.rank], maxRank: top.rank };
    }).sort((a, b) => {
      if (a.count !== b.count) return b.count - a.count;
      return b.maxRankValue - a.maxRankValue;
    });
  }
  /**
   * The jewel hand's name plus what breaks a tie: the jewel(s) and each
   * group's highest card, e.g. "Four of a Jewel, Onyx · 10 high · Q kicker",
   * "Jewel Full House, Ruby (K high) over Onyx (9 high)".
   */
  static describeJewelHand(cards, ranking) {
    const groups = this.jewelGroups(cards);
    const name = JEWEL_HAND_RANKING_NAMES[ranking];
    const [first, second] = groups;
    if (!first) return name;
    const jewel = (g) => g.jewel.charAt(0).toUpperCase() + g.jewel.slice(1);
    const high = (g) => `${RANK_SHORT[g.maxRank]} high`;
    const kickers = (from) => {
      const rest = groups.slice(from).map((g) => RANK_SHORT[g.maxRank]);
      return rest.length === 0 ? "" : ` \xB7 ${rest.join(" ")} kicker${rest.length > 1 ? "s" : ""}`;
    };
    switch (ranking) {
      case 6 /* FIVE_OF_A_JEWEL */:
        return `${name}, ${jewel(first)} \xB7 ${high(first)}`;
      case 5 /* FOUR_OF_A_JEWEL */:
      case 3 /* JEWEL_TRIPS */:
      case 1 /* JEWEL_PAIR */:
        return `${name}, ${jewel(first)} \xB7 ${high(first)}${kickers(1)}`;
      case 4 /* JEWEL_FULL_HOUSE */:
        return second ? `${name}, ${jewel(first)} (${high(first)}) over ${jewel(second)} (${high(second)})` : name;
      case 2 /* JEWEL_TWO_PAIR */:
        return second ? `${name}, ${jewel(first)} (${high(first)}) and ${jewel(second)} (${high(second)})${kickers(2)}` : name;
      default:
        return `${name} \xB7 ${groups.map((g) => RANK_SHORT[g.maxRank]).join(" ")}`;
    }
  }
  /**
   * Calculate numeric value for tie-breaking on the jewel axis (sibling of
   * calculateHandValue). Jewels have no ordinal value between them (see
   * poker-app-spec.md Section 2 — the metal-tier hierarchy was cut), so ties
   * within the same count-pattern are broken by the highest rank among each
   * jewel group's cards, largest group first — same kicker-style convention
   * as the rank axis, just applied to group membership instead of rank count.
   */
  static calculateJewelHandValue(cards, ranking) {
    let value = ranking * 1e7;
    this.jewelGroups(cards).forEach((item, index) => {
      const multiplier = Math.pow(100, 4 - index);
      value += item.maxRankValue * multiplier;
    });
    return value;
  }
  /**
   * Calculate numeric value for tie-breaking
   * Higher value = better hand within same ranking
   */
  static calculateHandValue(cards, ranking) {
    let value = ranking * 1e7;
    this.rankGroups(cards, ranking).forEach((item, index) => {
      const multiplier = Math.pow(100, 4 - index);
      value += item.value * multiplier;
    });
    return value;
  }
  /**
   * The ranks in a hand in tie-break order: grouped by count (largest group
   * first), then by rank, highest first. Both the score (calculateHandValue)
   * and the description (describeRankHand) come from this, so the
   * description always names exactly what decides a tie. Ghost cards
   * (rank counts as nothing) are excluded by getRankCounts.
   */
  static rankGroups(cards, ranking) {
    const rankCounts = this.getRankCounts(cards);
    const isStraightRanking = ranking === 4 /* STRAIGHT */ || ranking === 8 /* STRAIGHT_FLUSH */;
    const isWheel = isStraightRanking && ["A", "2", "3", "4", "5"].every((r) => rankCounts[r] === 1) && Object.keys(rankCounts).length === 5;
    return Object.entries(rankCounts).map(([rank, count]) => ({
      rank,
      count,
      value: isWheel && rank === "A" /* ACE */ ? 1 : RANK_VALUES[rank]
    })).sort((a, b) => {
      if (a.count !== b.count) return b.count - a.count;
      return b.value - a.value;
    });
  }
  /**
   * The hand's name plus what breaks a tie, e.g. "Four of a Kind, Jacks ·
   * 9 kicker", "Full House, Kings over Sevens", "Flush, Ace high · Q 9 6 3".
   * Built from rankGroups, so two hands with different scores never share a
   * description.
   */
  static describeRankHand(cards, ranking) {
    const groups = this.rankGroups(cards, ranking);
    const [first, second] = groups;
    const short = (from) => groups.slice(from).map((g) => RANK_SHORT[g.rank]);
    const kickers = (from) => {
      const rest = short(from);
      return rest.length === 0 ? "" : ` \xB7 ${rest.join(" ")} kicker${rest.length > 1 ? "s" : ""}`;
    };
    const name = HAND_RANKING_NAMES[ranking];
    if (!first) return name;
    switch (ranking) {
      case 9 /* ROYAL_FLUSH */:
        return name;
      case 8 /* STRAIGHT_FLUSH */:
      case 4 /* STRAIGHT */:
        return `${name}, ${RANK_WORD[first.value === 1 ? "5" /* FIVE */ : groups[0].rank]} high`;
      case 7 /* FOUR_OF_A_KIND */:
        return `${name}, ${RANK_PLURAL[first.rank]}${kickers(1)}`;
      case 6 /* FULL_HOUSE */:
        return second ? `${name}, ${RANK_PLURAL[first.rank]} over ${RANK_PLURAL[second.rank]}` : name;
      case 5 /* FLUSH */:
        return `${name}, ${RANK_WORD[first.rank]} high${groups.length > 1 ? ` \xB7 ${short(1).join(" ")}` : ""}`;
      case 3 /* THREE_OF_A_KIND */:
        return `${name}, ${RANK_PLURAL[first.rank]}${kickers(1)}`;
      case 2 /* TWO_PAIR */:
        return second ? `${name}, ${RANK_PLURAL[first.rank]} and ${RANK_PLURAL[second.rank]}${kickers(2)}` : name;
      case 1 /* PAIR */:
        return `Pair of ${RANK_PLURAL[first.rank]}${kickers(1)}`;
      default:
        return `${name}, ${RANK_WORD[first.rank]}${groups.length > 1 ? ` \xB7 ${short(1).join(" ")}` : ""}`;
    }
  }
  /**
   * Compare two poker hands
   * @returns 1 if hand1 > hand2, -1 if hand1 < hand2, 0 if tie
   */
  static compareHands(hand1, hand2) {
    if (hand1.ranking !== hand2.ranking) {
      return hand1.ranking > hand2.ranking ? 1 : -1;
    }
    if (hand1.value > hand2.value) return 1;
    if (hand1.value < hand2.value) return -1;
    return 0;
  }
  /**
   * Compare two jewel hands (sibling of compareHands)
   * @returns 1 if hand1 > hand2, -1 if hand1 < hand2, 0 if tie
   */
  static compareJewelHands(hand1, hand2) {
    if (hand1.ranking !== hand2.ranking) {
      return hand1.ranking > hand2.ranking ? 1 : -1;
    }
    if (hand1.value > hand2.value) return 1;
    if (hand1.value < hand2.value) return -1;
    return 0;
  }
  /**
   * Generate all k-combinations from an array
   * Used to find all possible 5-card hands
   */
  static getCombinations(array, k) {
    if (k === 0) return [[]];
    if (k > array.length) return [];
    const result = [];
    const combine = (start, current) => {
      if (current.length === k) {
        result.push([...current]);
        return;
      }
      for (let i = start; i <= array.length - (k - current.length); i++) {
        current.push(array[i]);
        combine(i + 1, current);
        current.pop();
      }
    };
    combine(0, []);
    return result;
  }
  /**
   * Determine winners from multiple player hands
   * Handles ties and returns all winners
   * @param hands - Array of hand evaluations with player IDs
   * @returns Array of winning player IDs
   */
  static determineWinners(hands) {
    if (hands.length === 0) return [];
    if (hands.length === 1) return [hands[0].playerId];
    let bestHand = hands[0].hand;
    for (let i = 1; i < hands.length; i++) {
      if (this.compareHands(hands[i].hand, bestHand) > 0) {
        bestHand = hands[i].hand;
      }
    }
    const winners = hands.filter(({ hand }) => this.compareHands(hand, bestHand) === 0).map(({ playerId }) => playerId);
    return winners;
  }
  /**
   * Determine winners from multiple player jewel hands (sibling of determineWinners)
   * @param hands - Array of jewel hand evaluations with player IDs
   * @returns Array of winning player IDs
   */
  static determineJewelWinners(hands) {
    if (hands.length === 0) return [];
    if (hands.length === 1) return [hands[0].playerId];
    let bestHand = hands[0].hand;
    for (let i = 1; i < hands.length; i++) {
      if (this.compareJewelHands(hands[i].hand, bestHand) > 0) {
        bestHand = hands[i].hand;
      }
    }
    return hands.filter(({ hand }) => this.compareJewelHands(hand, bestHand) === 0).map(({ playerId }) => playerId);
  }
  /**
   * "What could this line become" — a live readout for one of the 8 grid
   * lines from whatever's known so far, not just once it's fully revealed
   * (evaluateBestGridHand only ever considers complete lines). Once all 3
   * cells are in, this is the real evaluated hand, reusing the same tested
   * logic as evaluateBestGridHand (constrained to just this one line).
   * Before that, it's a heuristic over the known cards only (both hole
   * cards + whichever of the line's 3 cells are revealed) — a guaranteed
   * pair/trips already locked in, or a flush/straight draw signal — not a
   * full outs/probability calculation.
   * @param holeCards - The player's 2 hole cards
   * @param line - The 3 grid positions making up this line
   * @param cells - The current state of those 3 positions; `card: null` for a position not yet revealed to this viewer
   */
  static evaluateLinePotential(holeCards, line, cells, visibleCards) {
    const revealed = cells.filter((c) => c.card !== null);
    const revealedCount = revealed.length;
    if (revealedCount === 3) {
      const gridCards = revealed.map(({ position, card }) => ({ position, card, revealed: true }));
      const hand = this.evaluateBestGridHand(holeCards, gridCards, [line]);
      return { revealedCount, status: "complete", label: hand.name, hand, strength: 1e3 + hand.ranking };
    }
    const known = [...holeCards, ...revealed.map((c) => c.card)];
    const signal = this.rankPotentialSignal(known);
    let bestCase;
    if (revealedCount === 2 && visibleCards) {
      const found = this.findBestCaseRankCard(holeCards, cells, visibleCards);
      if (found) bestCase = { card: found.card, name: found.hand.name, ranking: found.hand.ranking };
    }
    return {
      revealedCount,
      status: revealedCount === 0 ? "empty" : "partial",
      label: signal.label,
      strength: signal.strength,
      bestCase
    };
  }
  /** Jewel-axis counterpart of evaluateLinePotential. */
  static evaluateJewelLinePotential(holeCards, line, cells, visibleCards) {
    const revealed = cells.filter((c) => c.card !== null);
    const revealedCount = revealed.length;
    if (revealedCount === 3) {
      const gridCards = revealed.map(({ position, card }) => ({ position, card, revealed: true }));
      const hand = this.evaluateBestGridHandByJewel(holeCards, gridCards, [line]);
      return { revealedCount, status: "complete", label: hand.name, hand, strength: 1e3 + hand.ranking };
    }
    const known = [...holeCards, ...revealed.map((c) => c.card)];
    const signal = this.jewelPotentialSignal(known);
    let bestCase;
    if (revealedCount === 2 && visibleCards) {
      const found = this.findBestCaseJewelCard(holeCards, cells, visibleCards);
      if (found) bestCase = { card: found.card, name: found.hand.name, ranking: found.hand.ranking };
    }
    return {
      revealedCount,
      status: revealedCount === 0 ? "empty" : "partial",
      label: signal.label,
      strength: signal.strength,
      bestCase
    };
  }
  /**
   * Rank-axis heuristic for a line that isn't fully revealed yet, paired
   * with a comparable strength (higher is better) so callers can pick the
   * strongest line among several. Ghost cards (rank counts as nothing) are
   * excluded from the rank tally, same as the real evaluator; Orphan cards
   * (no suit) are excluded from the flush-draw tally.
   */
  static rankPotentialSignal(known) {
    if (known.length === 0) return { strength: 0, label: "Too early to tell" };
    const rankCounts = /* @__PURE__ */ new Map();
    for (const card of known) {
      if (rankIsDead(card)) continue;
      rankCounts.set(card.rank, (rankCounts.get(card.rank) || 0) + 1);
    }
    const counts = [...rankCounts.values()].sort((a, b) => b - a);
    if (counts[0] >= 4) return { strength: 7, label: "Four of a Kind locked in" };
    if (counts[0] === 3) return { strength: 6, label: "Three of a Kind locked in" };
    if (counts[0] === 2 && counts[1] === 2) return { strength: 5, label: "Two Pair locked in" };
    if (counts[0] === 2) return { strength: 4, label: "Pair locked in" };
    const maxSuit = this.maxSuitCount(known);
    if (maxSuit >= 3) return { strength: 3, label: `Flush draw (${maxSuit}/5 suited)` };
    const values = [...new Set(known.filter((c) => !rankIsDead(c)).map((c) => RANK_VALUES[c.rank]))].sort((a, b) => a - b);
    if (values.length >= 3 && values[values.length - 1] - values[0] <= 4) {
      return { strength: 2, label: "Straight draw" };
    }
    return { strength: 1, label: "High card so far" };
  }
  /** Jewel-axis counterpart of rankPotentialSignal. Void cards (jewel counts as nothing) are excluded, same as the real evaluator. */
  static jewelPotentialSignal(known) {
    if (known.length === 0) return { strength: 0, label: "Too early to tell" };
    const jewelCounts = /* @__PURE__ */ new Map();
    for (const card of known) {
      if (jewelIsDead(card)) continue;
      jewelCounts.set(card.jewel, (jewelCounts.get(card.jewel) || 0) + 1);
    }
    const counts = [...jewelCounts.values()].sort((a, b) => b - a);
    if (counts[0] >= 4) return { strength: 5, label: "Four of a Jewel locked in" };
    if (counts[0] === 3) return { strength: 4, label: "Jewel Three of a Kind locked in" };
    if (counts[0] === 2 && counts[1] === 2) return { strength: 3, label: "Jewel Two Pair locked in" };
    if (counts[0] === 2) return { strength: 2, label: "Jewel Pair locked in" };
    return { strength: 1, label: "No jewel match yet" };
  }
  /**
   * True best-case preview for a line with exactly one cell still
   * unrevealed — not a heuristic, but an exhaustive search of every
   * rank+suit not yet visible to the viewer (their hole cards + every
   * revealed community cell across the whole grid, not just this line's),
   * each tried in the missing slot with the real evaluator, keeping
   * whichever produces the strongest hand. Jewel doesn't affect the rank
   * axis, so the placeholder jewel used for the search is irrelevant.
   * @param cells - The line's 3 cells; must have exactly 2 revealed (1 `card: null`) or this returns null
   * @param visibleCards - Every card already visible to the viewer (hole cards + all revealed community cells), used to exclude cards no longer in the deck
   */
  static findBestCaseRankCard(holeCards, cells, visibleCards) {
    const known = cells.filter((c) => c.card !== null);
    if (known.length !== 2) return null;
    const used = new Set(visibleCards.map((c) => `${c.rank}-${c.suit}`));
    let best = null;
    for (const rank of Object.values(Rank)) {
      for (const suit of Object.values(Suit)) {
        const key = `${rank}-${suit}`;
        if (used.has(key)) continue;
        const candidate = { rank, suit, jewel: "ruby" /* RUBY */, id: `outs-${key}` };
        const lineCards = [known[0].card, known[1].card, candidate];
        const resolvedHoleCards = this.resolveJoker(this.resolveHighflyerAndLimbo(holeCards, lineCards), lineCards);
        const hand = this.evaluateHand([...resolvedHoleCards, ...lineCards]);
        if (!best || this.compareHands(hand, best.hand) > 0) {
          best = { card: candidate, hand };
        }
      }
    }
    return best;
  }
  /**
   * Jewel-axis counterpart of findBestCaseRankCard. Rank/suit don't affect
   * jewel-count comparisons, only the tie-break kicker
   * (calculateJewelHandValue's maxRankValue), so the search jointly tries
   * every unseen rank (paired with any one still-available suit of that
   * rank — the suit itself is irrelevant) against all 4 jewels, finding the
   * true best (rank, jewel) combination rather than fixing rank first.
   */
  static findBestCaseJewelCard(holeCards, cells, visibleCards) {
    const known = cells.filter((c) => c.card !== null);
    if (known.length !== 2) return null;
    const usedRankSuit = new Set(visibleCards.map((c) => `${c.rank}-${c.suit}`));
    const availableSuitByRank = /* @__PURE__ */ new Map();
    for (const rank of Object.values(Rank)) {
      for (const suit of Object.values(Suit)) {
        if (!usedRankSuit.has(`${rank}-${suit}`)) {
          availableSuitByRank.set(rank, suit);
          break;
        }
      }
    }
    let best = null;
    for (const [rank, suit] of availableSuitByRank) {
      for (const jewel of JEWELS) {
        const candidate = { rank, suit, jewel, id: `outs-${rank}-${jewel}` };
        const lineCards = [known[0].card, known[1].card, candidate];
        const resolvedHoleCards = this.resolveChameleon(holeCards, lineCards);
        const hand = this.evaluateJewelHand([...resolvedHoleCards, ...lineCards]);
        if (!best || this.compareJewelHands(hand, best.hand) > 0) {
          best = { card: candidate, hand };
        }
      }
    }
    return best;
  }
  /**
   * Get a human-readable description of a hand
   */
  static describeHand(evaluation) {
    const { name, cards } = evaluation;
    const highCard = cards.map((c) => RANK_VALUES[c.rank]).reduce((max, val) => Math.max(max, val), 0);
    const highCardRank = Object.entries(RANK_VALUES).find(
      ([, val]) => val === highCard
    )?.[0];
    switch (evaluation.ranking) {
      case 9 /* ROYAL_FLUSH */:
        return "Royal Flush";
      case 8 /* STRAIGHT_FLUSH */:
        return `Straight Flush, ${highCardRank} high`;
      case 7 /* FOUR_OF_A_KIND */:
        return `${name}`;
      case 6 /* FULL_HOUSE */:
        return `${name}`;
      case 5 /* FLUSH */:
        return `${name}, ${highCardRank} high`;
      case 4 /* STRAIGHT */:
        return `${name}, ${highCardRank} high`;
      default:
        return name;
    }
  }
};

// src/engine/BettingRound.ts
function livePots(players) {
  const live = (p) => p.status === "active" /* ACTIVE */ || p.status === "all_in" /* ALL_IN */;
  const caps = [
    ...new Set(players.filter((p) => p.status === "all_in" /* ALL_IN */ && p.totalBet > 0).map((p) => p.totalBet))
  ].sort((a, b) => a - b);
  const pots = [];
  let lower = 0;
  for (const upper of [...caps, Infinity]) {
    const amount = players.reduce(
      (sum, p) => sum + Math.max(0, Math.min(p.totalBet, upper) - Math.min(p.totalBet, lower)),
      0
    );
    const eligiblePlayers = players.filter((p) => live(p) && (p.status === "active" /* ACTIVE */ || p.totalBet > lower)).map((p) => p.id);
    if (amount > 0) pots.push({ amount, eligiblePlayers });
    lower = upper;
  }
  return pots;
}
var BettingRound = class {
  constructor(anteAmount) {
    this.currentBet = 0;
    this.pots = [{ amount: 0, eligiblePlayers: [] }];
    this.anteAmount = anteAmount;
    this.actions = [];
    this.lastRaiseSize = 0;
  }
  /**
   * No-limit betting with the standard minimums (decided 2026-10-03): an
   * opening bet is at least the ante, and a raise at least the size of the
   * last bet or raise this round (never less than the ante). Going all-in
   * for less is always allowed. This is that minimum — for a BET the
   * amount itself, for a RAISE the amount on top of the current bet.
   */
  getMinRaise() {
    return Math.max(this.anteAmount, this.lastRaiseSize);
  }
  /**
   * Collect antes from all active players
   * @param players - Array of players
   * @returns Updated players with antes collected
   */
  collectAntes(players) {
    const updated = players.map((player) => {
      if (player.status === "folded" /* FOLDED */ || player.status === "disconnected" /* DISCONNECTED */) {
        return player;
      }
      if (player.chips >= this.anteAmount) {
        const chips = player.chips - this.anteAmount;
        return {
          ...player,
          chips,
          currentBet: this.anteAmount,
          totalBet: this.anteAmount,
          ...chips === 0 ? { status: "all_in" /* ALL_IN */ } : {}
        };
      }
      if (player.chips > 0) {
        const allInAmount = player.chips;
        return {
          ...player,
          chips: 0,
          currentBet: allInAmount,
          totalBet: allInAmount,
          status: "all_in" /* ALL_IN */
        };
      }
      return {
        ...player,
        status: "folded" /* FOLDED */
      };
    });
    const totalAntes = updated.reduce((sum, p) => sum + (p.currentBet || 0), 0);
    this.pots[0].amount += totalAntes;
    this.pots[0].eligiblePlayers = updated.filter((p) => p.status !== "folded" /* FOLDED */ && p.status !== "disconnected" /* DISCONNECTED */).map((p) => p.id);
    return updated;
  }
  /**
   * Process a player action (fold, check, call, raise, bet, all-in)
   * @param player - Player making the action
   * @param action - Action type
   * @param amount - Optional bet amount
   * @returns Result of the action
   */
  processAction(player, action, amount) {
    if (player.status !== "active" /* ACTIVE */) {
      return {
        success: false,
        error: "Player is not active",
        amountAdded: 0,
        newChipCount: player.chips,
        newStatus: player.status
      };
    }
    switch (action) {
      case "fold" /* FOLD */:
        return this.handleFold(player);
      case "check" /* CHECK */:
        return this.handleCheck(player);
      case "call" /* CALL */:
        return this.handleCall(player);
      case "raise" /* RAISE */:
        return this.handleRaise(player, amount || 0);
      case "bet" /* BET */:
        return this.handleBet(player, amount || 0);
      case "all_in" /* ALL_IN */:
        return this.handleAllIn(player);
      default:
        return {
          success: false,
          error: "Invalid action type",
          amountAdded: 0,
          newChipCount: player.chips,
          newStatus: player.status
        };
    }
  }
  /**
   * Handle fold action
   */
  handleFold(player) {
    this.logAction(player.id, "fold" /* FOLD */);
    return {
      success: true,
      amountAdded: 0,
      newChipCount: player.chips,
      newStatus: "folded" /* FOLDED */
    };
  }
  /**
   * Handle check action
   */
  handleCheck(player) {
    const amountToCall = this.currentBet - (player.currentBet || 0);
    if (amountToCall > 0) {
      return {
        success: false,
        error: `Cannot check - must call ${amountToCall}`,
        amountAdded: 0,
        newChipCount: player.chips,
        newStatus: player.status
      };
    }
    this.logAction(player.id, "check" /* CHECK */);
    return {
      success: true,
      amountAdded: 0,
      newChipCount: player.chips,
      newStatus: player.status
    };
  }
  /**
   * Handle call action
   */
  handleCall(player) {
    const amountToCall = this.currentBet - (player.currentBet || 0);
    if (amountToCall <= 0) {
      return {
        success: false,
        error: "Nothing to call - use check instead",
        amountAdded: 0,
        newChipCount: player.chips,
        newStatus: player.status
      };
    }
    if (player.chips < amountToCall) {
      return this.handleAllIn(player);
    }
    this.logAction(player.id, "call" /* CALL */, amountToCall);
    return {
      success: true,
      amountAdded: amountToCall,
      newChipCount: player.chips - amountToCall,
      newStatus: this.statusAfterSpending(player, amountToCall)
    };
  }
  /**
   * Handle raise action
   */
  handleRaise(player, raiseAmount) {
    if (raiseAmount <= 0) {
      return {
        success: false,
        error: "Raise amount must be positive",
        amountAdded: 0,
        newChipCount: player.chips,
        newStatus: player.status
      };
    }
    const amountToCall = this.currentBet - (player.currentBet || 0);
    const totalAmount = amountToCall + raiseAmount;
    if (player.chips < totalAmount) {
      return {
        success: false,
        error: `Not enough chips - have ${player.chips}, need ${totalAmount}`,
        amountAdded: 0,
        newChipCount: player.chips,
        newStatus: player.status
      };
    }
    const minRaise = this.getMinRaise();
    if (raiseAmount < minRaise && totalAmount < player.chips) {
      return {
        success: false,
        error: `Minimum raise is ${minRaise}`,
        amountAdded: 0,
        newChipCount: player.chips,
        newStatus: player.status
      };
    }
    this.currentBet += raiseAmount;
    if (raiseAmount >= minRaise) this.lastRaiseSize = raiseAmount;
    this.logAction(player.id, "raise" /* RAISE */, totalAmount);
    return {
      success: true,
      amountAdded: totalAmount,
      newChipCount: player.chips - totalAmount,
      newStatus: this.statusAfterSpending(player, totalAmount)
    };
  }
  /**
   * Handle bet action (when no current bet exists)
   */
  handleBet(player, betAmount) {
    if (this.currentBet > 0) {
      return {
        success: false,
        error: "Cannot bet - use raise instead",
        amountAdded: 0,
        newChipCount: player.chips,
        newStatus: player.status
      };
    }
    if (betAmount <= 0) {
      return {
        success: false,
        error: "Bet amount must be positive",
        amountAdded: 0,
        newChipCount: player.chips,
        newStatus: player.status
      };
    }
    if (player.chips < betAmount) {
      return {
        success: false,
        error: `Not enough chips - have ${player.chips}, need ${betAmount}`,
        amountAdded: 0,
        newChipCount: player.chips,
        newStatus: player.status
      };
    }
    const minBet = this.getMinRaise();
    if (betAmount < minBet && betAmount < player.chips) {
      return {
        success: false,
        error: `Minimum bet is ${minBet}`,
        amountAdded: 0,
        newChipCount: player.chips,
        newStatus: player.status
      };
    }
    this.currentBet = betAmount;
    if (betAmount >= minBet) this.lastRaiseSize = betAmount;
    this.logAction(player.id, "bet" /* BET */, betAmount);
    return {
      success: true,
      amountAdded: betAmount,
      newChipCount: player.chips - betAmount,
      newStatus: this.statusAfterSpending(player, betAmount)
    };
  }
  /**
   * Handle all-in action
   */
  handleAllIn(player) {
    if (player.chips <= 0) {
      return {
        success: false,
        error: "No chips to go all-in with",
        amountAdded: 0,
        newChipCount: 0,
        newStatus: player.status
      };
    }
    const allInAmount = player.chips;
    this.logAction(player.id, "all_in" /* ALL_IN */, allInAmount);
    const newTotalBet = (player.currentBet || 0) + allInAmount;
    if (newTotalBet > this.currentBet) {
      const raisedBy = newTotalBet - this.currentBet;
      if (raisedBy >= this.getMinRaise()) this.lastRaiseSize = raisedBy;
      this.currentBet = newTotalBet;
    }
    return {
      success: true,
      amountAdded: allInAmount,
      newChipCount: 0,
      newStatus: "all_in" /* ALL_IN */
    };
  }
  /**
   * Calculate pots including side pots for all-in situations
   * @param players - All players in the hand
   * @returns Array of pots with eligible players
   */
  calculatePots(players) {
    const contributors = players.filter((p) => p.totalBet > 0);
    if (contributors.length === 0) {
      return [{ amount: 0, eligiblePlayers: [] }];
    }
    const levels = [...new Set(contributors.map((p) => p.totalBet))].sort((a, b) => a - b);
    const pots = [];
    let previousLevel = 0;
    for (const level of levels) {
      const layerContributors = contributors.filter((p) => p.totalBet >= level);
      const layerAmount = (level - previousLevel) * layerContributors.length;
      if (layerAmount > 0) {
        const eligible = layerContributors.filter(
          (p) => p.status !== "folded" /* FOLDED */ && p.status !== "disconnected" /* DISCONNECTED */
        ).map((p) => p.id);
        pots.push({ amount: layerAmount, eligiblePlayers: eligible });
      }
      previousLevel = level;
    }
    const merged = [];
    for (const pot of pots) {
      if (pot.eligiblePlayers.length > 0 || merged.length === 0) {
        merged.push({ ...pot });
      } else {
        merged[merged.length - 1].amount += pot.amount;
      }
    }
    while (merged.length > 1 && merged[0].eligiblePlayers.length === 0) {
      merged[1].amount += merged[0].amount;
      merged.shift();
    }
    return merged.length > 0 ? merged : [{ amount: 0, eligiblePlayers: [] }];
  }
  /**
   * Get current bet amount
   */
  getCurrentBet() {
    return this.currentBet;
  }
  /**
   * Get main pot amount
   */
  getMainPot() {
    return this.pots[0]?.amount || 0;
  }
  /**
   * Get all pots
   */
  getPots() {
    return [...this.pots];
  }
  /**
   * Get all actions in this round
   */
  getActions() {
    return [...this.actions];
  }
  /**
   * Reset betting round for new phase
   */
  resetForNewRound() {
    this.currentBet = 0;
    this.actions = [];
    this.lastRaiseSize = 0;
  }
  /**
   * Check if betting round is complete
   * @param players - Active players
   * @returns true if all active players have matched the current bet
   */
  isRoundComplete(players) {
    const activePlayers = players.filter((p) => p.status === "active" /* ACTIVE */);
    if (activePlayers.length === 0) return true;
    if (activePlayers.length === 1) return activePlayers[0].currentBet >= this.currentBet;
    const actedThisRound = new Set(this.actions.map((a) => a.playerId));
    const everyoneActed = activePlayers.every((p) => actedThisRound.has(p.id));
    const allMatched = activePlayers.every((p) => p.currentBet === this.currentBet);
    return everyoneActed && allMatched;
  }
  /** Status after putting `amount` chips in — spending the last chip makes the player all-in. */
  statusAfterSpending(player, amount) {
    return player.chips - amount === 0 ? "all_in" /* ALL_IN */ : player.status;
  }
  /**
   * Log a player action
   */
  logAction(playerId, type, amount) {
    this.actions.push({
      playerId,
      type,
      amount,
      timestamp: Date.now()
    });
  }
};

// src/engine/GamePhaseManager.ts
var GamePhaseManager = class {
  constructor() {
    this.currentPhase = "ante" /* ANTE */;
    this.gridCards = [];
  }
  /**
   * Initialize grid with 9 cards (all unrevealed)
   * @param cards - 9 cards for the 3x3 grid
   */
  initializeGrid(cards) {
    if (cards.length !== 9) {
      throw new Error("Grid must contain exactly 9 cards");
    }
    this.gridCards = GRID_POSITIONS.map((position, index) => ({
      card: cards[index],
      position,
      revealed: false
    }));
  }
  /**
   * Get current game phase
   */
  getCurrentPhase() {
    return this.currentPhase;
  }
  /**
   * Get all grid cards — a true copy (each GridCard object cloned, not
   * just the array wrapper). revealPositions() mutates a card's `revealed`
   * flag in place; a shallow `[...this.gridCards]` still shares those same
   * card objects, so a snapshot taken before a reveal would silently show
   * as "already revealed" too once the mutation happens — exactly the bug
   * that made every before/after reveal diff in GameService come out
   * empty, no matter how the diffing code itself looked.
   */
  getGridCards() {
    return this.gridCards.map((gc) => ({ ...gc }));
  }
  /**
   * Record who can see a still-hidden cell (Seer). Kept here — the grid's
   * source of truth — since GridPoker rebuilds its copies of the grid from
   * getGridCards() at every phase change and in getGameState().
   */
  setPrivatelyVisibleTo(position, playerIds) {
    const cell = this.gridCards.find((gc) => gc.position === position);
    if (cell) cell.privatelyVisibleTo = [...playerIds];
  }
  /**
   * Get only revealed grid cards
   */
  getRevealedCards() {
    return this.gridCards.filter((gc) => gc.revealed);
  }
  /**
   * Get only unrevealed grid cards
   */
  getUnrevealedCards() {
    return this.gridCards.filter((gc) => !gc.revealed);
  }
  /**
   * Advance to the next game phase
   * @returns Transition information
   */
  advancePhase() {
    const previousPhase = this.currentPhase;
    let revealedPositions = [];
    switch (this.currentPhase) {
      case "ante" /* ANTE */:
        this.currentPhase = "pre_flop" /* PRE_FLOP */;
        break;
      case "pre_flop" /* PRE_FLOP */:
        this.currentPhase = "round_1" /* ROUND_1 */;
        revealedPositions = this.revealPositions(GRID_REVEAL_PHASES.ROUND_1);
        break;
      case "round_1" /* ROUND_1 */:
        this.currentPhase = "round_2" /* ROUND_2 */;
        revealedPositions = this.revealPositions(GRID_REVEAL_PHASES.ROUND_2);
        break;
      case "round_2" /* ROUND_2 */:
        this.currentPhase = "round_3" /* ROUND_3 */;
        revealedPositions = this.revealPositions(GRID_REVEAL_PHASES.ROUND_3);
        break;
      case "round_3" /* ROUND_3 */:
        this.currentPhase = "showdown" /* SHOWDOWN */;
        break;
      case "showdown" /* SHOWDOWN */:
        this.currentPhase = "ended" /* ENDED */;
        break;
      case "ended" /* ENDED */:
        break;
      default:
        throw new Error(`Unknown phase: ${this.currentPhase}`);
    }
    return {
      previousPhase,
      currentPhase: this.currentPhase,
      revealedPositions,
      isComplete: this.currentPhase === "ended" /* ENDED */
    };
  }
  /**
   * Reveal specific grid positions
   * @param positions - Positions to reveal
   * @returns Array of revealed positions
   */
  revealPositions(positions) {
    const revealed = [];
    for (const position of positions) {
      const card = this.gridCards.find((gc) => gc.position === position);
      if (card && !card.revealed) {
        card.revealed = true;
        revealed.push(position);
      }
    }
    return revealed;
  }
  /**
   * Check if a specific phase requires a betting round
   */
  requiresBetting(phase) {
    return phase === "pre_flop" /* PRE_FLOP */ || phase === "round_1" /* ROUND_1 */ || phase === "round_2" /* ROUND_2 */ || phase === "round_3" /* ROUND_3 */;
  }
  /**
   * Check if current phase is a betting phase
   */
  isCurrentPhaseBetting() {
    return this.requiresBetting(this.currentPhase);
  }
  /**
   * Get the next phase without advancing
   */
  getNextPhase() {
    switch (this.currentPhase) {
      case "ante" /* ANTE */:
        return "pre_flop" /* PRE_FLOP */;
      case "pre_flop" /* PRE_FLOP */:
        return "round_1" /* ROUND_1 */;
      case "round_1" /* ROUND_1 */:
        return "round_2" /* ROUND_2 */;
      case "round_2" /* ROUND_2 */:
        return "round_3" /* ROUND_3 */;
      case "round_3" /* ROUND_3 */:
        return "showdown" /* SHOWDOWN */;
      case "showdown" /* SHOWDOWN */:
        return "ended" /* ENDED */;
      default:
        return "ended" /* ENDED */;
    }
  }
  /**
   * Reset to initial phase (for new hand)
   */
  reset() {
    this.currentPhase = "ante" /* ANTE */;
    this.gridCards = [];
  }
  /**
   * Manually set phase (for testing or recovery)
   */
  setPhase(phase) {
    this.currentPhase = phase;
  }
  /**
   * Get positions that should be revealed in a specific phase
   */
  static getRevealPositionsForPhase(phase) {
    switch (phase) {
      case "round_1" /* ROUND_1 */:
        return [...GRID_REVEAL_PHASES.ROUND_1];
      case "round_2" /* ROUND_2 */:
        return [...GRID_REVEAL_PHASES.ROUND_2];
      case "round_3" /* ROUND_3 */:
        return [...GRID_REVEAL_PHASES.ROUND_3];
      default:
        return [];
    }
  }
  /**
   * Get count of revealed cards
   */
  getRevealedCount() {
    return this.gridCards.filter((gc) => gc.revealed).length;
  }
  /**
   * Validate phase transition
   * @param from - Current phase
   * @param to - Target phase
   * @returns true if transition is valid
   */
  static isValidTransition(from, to) {
    const validTransitions = {
      ["ante" /* ANTE */]: ["pre_flop" /* PRE_FLOP */],
      ["pre_flop" /* PRE_FLOP */]: ["round_1" /* ROUND_1 */],
      ["round_1" /* ROUND_1 */]: ["round_2" /* ROUND_2 */],
      ["round_2" /* ROUND_2 */]: ["round_3" /* ROUND_3 */],
      ["round_3" /* ROUND_3 */]: ["showdown" /* SHOWDOWN */],
      ["showdown" /* SHOWDOWN */]: ["ended" /* ENDED */],
      ["ended" /* ENDED */]: []
    };
    return validTransitions[from]?.includes(to) || false;
  }
  /**
   * Get grid card at specific position
   */
  getCardAtPosition(position) {
    return this.gridCards.find((gc) => gc.position === position);
  }
  /**
   * Check if position is revealed
   */
  isPositionRevealed(position) {
    const card = this.getCardAtPosition(position);
    return card?.revealed || false;
  }
  /**
   * Get grid layout as 3x3 matrix
   * @returns 3x3 array of GridCard (or null for unrevealed)
   */
  getGridMatrix() {
    const matrix = [
      [null, null, null],
      [null, null, null],
      [null, null, null]
    ];
    for (const gridCard of this.gridCards) {
      const row = Math.floor((gridCard.position - 1) / 3);
      const col = (gridCard.position - 1) % 3;
      matrix[row][col] = gridCard.revealed ? gridCard : null;
    }
    return matrix;
  }
  /**
   * Get phase name for display
   */
  static getPhaseName(phase) {
    const names = {
      ["ante" /* ANTE */]: "Ante Collection",
      ["pre_flop" /* PRE_FLOP */]: "Pre-Flop",
      ["round_1" /* ROUND_1 */]: "Round 1 - Corners",
      ["round_2" /* ROUND_2 */]: "Round 2 - Diamond",
      ["round_3" /* ROUND_3 */]: "Round 3 - Center",
      ["showdown" /* SHOWDOWN */]: "Showdown",
      ["ended" /* ENDED */]: "Hand Complete"
    };
    return names[phase] || "Unknown Phase";
  }
};

// src/engine/SpecialCardDealer.ts
function dealSpecialCards(cards, random = secureRandom, options = {}) {
  const dealt = options.dealt ?? /* @__PURE__ */ new Set();
  rollSpecial(cards[0], random, dealt);
  const excludeForSecond = new Set(dealt);
  if (cards[0].special) excludeForSecond.add(cards[0].special);
  rollSpecial(cards[1], random, excludeForSecond);
  enforcePairingRule(cards);
  for (const card of cards) {
    if (card.special) dealt.add(card.special);
  }
  if (options.applyEffects !== false) {
    resolveInstantSpecials(cards);
  }
}
function rollSpecial(card, random, excluded) {
  if (random() >= SPECIAL_CARD_DEAL_CHANCE) {
    return;
  }
  const type = pickSpecialCardType(random, excluded);
  if (type) card.special = type;
}
function pickSpecialCardType(random, excluded) {
  const pack = [];
  for (const tier of [1, 2, 3]) {
    for (const type of SPECIAL_CARD_TIERS[tier]) {
      if (!excluded.has(type)) pack.push({ type, weight: SPECIAL_CARD_TIER_WEIGHTS[tier] });
    }
  }
  if (pack.length === 0) return void 0;
  const roll = random() * pack.reduce((sum, c) => sum + c.weight, 0);
  let cumulative = 0;
  for (const { type, weight } of pack) {
    cumulative += weight;
    if (roll < cumulative) return type;
  }
  return pack[pack.length - 1].type;
}
function enforcePairingRule(cards) {
  const [a, b] = cards;
  if (!a.special || !b.special) {
    return;
  }
  const signA = SPECIAL_CARD_INFO[a.special].sign;
  const signB = SPECIAL_CARD_INFO[b.special].sign;
  if (signA === signB) {
    delete b.special;
  }
}
function resolveInstantSpecials(cards) {
  const [a, b] = cards;
  const originalRankA = a.rank;
  const originalSuitA = a.suit;
  const originalJewelA = a.jewel;
  const originalRankB = b.rank;
  const originalSuitB = b.suit;
  const originalJewelB = b.jewel;
  if (a.special === "numerology" /* NUMEROLOGY */) {
    a.rank = originalRankB;
  } else if (a.special === "suitor" /* SUITOR */) {
    a.suit = originalSuitB;
  } else if (a.special === "jeweler" /* JEWELER */) {
    a.jewel = originalJewelB;
  }
  if (b.special === "numerology" /* NUMEROLOGY */) {
    b.rank = originalRankA;
  } else if (b.special === "suitor" /* SUITOR */) {
    b.suit = originalSuitA;
  } else if (b.special === "jeweler" /* JEWELER */) {
    b.jewel = originalJewelA;
  }
}

// src/engine/SpecialCardResolver.ts
function getShapeSetForPlayer(holeCards) {
  const hasAnchor = holeCards.some((card) => card.special === "anchor" /* ANCHOR */);
  if (hasAnchor) return GRID_LINES_SNAKE;
  const hasCrossed = holeCards.some((card) => card.special === "crossed" /* CROSSED */);
  if (hasCrossed) return GRID_LINES_STRAIGHT;
  return GRID_LINES;
}
function resolveThief(holeCards, gridCards) {
  const thiefCard = holeCards.find((card) => card.special === "thief" /* THIEF */);
  if (!thiefCard) return;
  const diamondPositions = [2, 4, 6, 8];
  const cardAtPosition = /* @__PURE__ */ new Map();
  for (const gridCard of gridCards) {
    cardAtPosition.set(gridCard.position, gridCard.card);
  }
  const diamondCards = diamondPositions.map((position) => cardAtPosition.get(position)).filter((card) => !!card);
  let bestRank = diamondCards[0]?.rank ?? thiefCard.rank;
  let bestHand = null;
  for (const candidate of diamondCards) {
    const candidateHoleCards = holeCards.map(
      (c) => c === thiefCard ? { ...c, rank: candidate.rank } : c
    );
    const hand = HandEvaluator.evaluateBestGridHand(
      candidateHoleCards,
      gridCards,
      GRID_LINES_COMPLETE_BEFORE_CENTER
    );
    if (!bestHand || HandEvaluator.compareHands(hand, bestHand) > 0) {
      bestHand = hand;
      bestRank = candidate.rank;
    }
  }
  thiefCard.rank = bestRank;
}
function resolveImpersonator(holeCards, centerCard) {
  const impersonatorCard = holeCards.find((card) => card.special === "impersonator" /* IMPERSONATOR */);
  if (!impersonatorCard) return;
  impersonatorCard.rank = centerCard.rank;
  impersonatorCard.suit = centerCard.suit;
  impersonatorCard.jewel = centerCard.jewel;
}
function resolveLimbo(holeCards, gridCards) {
  const limboCard = holeCards.find((card) => card.special === "limbo" /* LIMBO */);
  if (!limboCard) return;
  const grid = gridCards.map((gc) => gc.card);
  const rarest = (values, of) => values.reduce(
    (best, v) => grid.filter((c) => of(c) === v).length < grid.filter((c) => of(c) === best).length ? v : best
  );
  limboCard.rank = Object.values(Rank).find((rank) => !grid.some((c) => c.rank === rank)) ?? "2" /* TWO */;
  limboCard.suit = rarest(Object.values(Suit), (c) => c.suit);
  limboCard.jewel = rarest(Object.values(Jewel), (c) => c.jewel);
}
function resolveSeer(players, centerGridCard) {
  const holder = players.find((p) => p.cards.some((card) => card.special === "seer" /* SEER */));
  if (!holder) return;
  centerGridCard.privatelyVisibleTo = [...centerGridCard.privatelyVisibleTo ?? [], holder.id];
}
var INSIGHT_HIDES = {
  ["oracle" /* ORACLE */]: "jewel",
  // rank + suit
  ["soothsayer" /* SOOTHSAYER */]: "rank",
  // suit + jewel
  ["omnipotent" /* OMNIPOTENT */]: null
  // rank + suit + jewel
};
function insightCardOf(holeCards) {
  const card = holeCards.find(
    (c) => c.special && (c.special in INSIGHT_HIDES || c.special === "spy" /* SPY */)
  );
  return card?.special ?? null;
}
function getInsightView(insight, opponentCards) {
  if (insight === "spy" /* SPY */) {
    return opponentCards.map((card) => card.special ? { hidden: true, special: card.special } : { hidden: true });
  }
  const hides = INSIGHT_HIDES[insight] ?? null;
  return opponentCards.map((card, index) => {
    const { special, ...base } = card;
    const seen = special ? { ...base, unrevealedSpecial: true } : card;
    if (!hides) return seen;
    return { ...seen, [hides]: PLACEHOLDER[hides], concealed: hides, id: `seen-${index}` };
  });
}
var CONCEALS = {
  ["prank" /* PRANK */]: "rank",
  ["blind" /* BLIND */]: "suit",
  ["buried" /* BURIED */]: "jewel"
};
var COPIES = {
  rank: "numerology" /* NUMEROLOGY */,
  suit: "suitor" /* SUITOR */,
  jewel: "jeweler" /* JEWELER */
};
var PLACEHOLDER = {
  rank: "2" /* TWO */,
  suit: "spades" /* SPADES */,
  jewel: "onyx" /* ONYX */
};
function concealFromHolder(holeCards, { includeCopies = true } = {}) {
  const hidden = holeCards.map((card) => card.special ? CONCEALS[card.special] : void 0).filter((attribute) => !!attribute);
  if (hidden.length === 0) return holeCards;
  return holeCards.map((card, index) => {
    const attribute = (card.special ? CONCEALS[card.special] : void 0) ?? (includeCopies ? hidden.find((a) => card.special === COPIES[a]) : void 0);
    if (!attribute) return card;
    return { ...card, [attribute]: PLACEHOLDER[attribute], concealed: attribute, id: `concealed-${index}` };
  });
}
function specialsTurnedOver(phase) {
  return phase !== "ante" /* ANTE */ && phase !== "pre_flop" /* PRE_FLOP */;
}
function holderView(holeCards, phase, effectsOn = true, keptFaceDown = false) {
  if (keptFaceDown) return holderView(holeCards, "pre_flop" /* PRE_FLOP */, effectsOn);
  if (phase === "showdown" /* SHOWDOWN */ || phase === "ended" /* ENDED */) return holeCards;
  const turnedOver = specialsTurnedOver(phase);
  const cards = effectsOn ? concealFromHolder(holeCards, { includeCopies: turnedOver }) : holeCards;
  if (turnedOver) return cards;
  return cards.map((card) => {
    if (!card.special) return card;
    const { special: _special, ...rest } = card;
    return { ...rest, unrevealedSpecial: true };
  });
}
var BLOCKS = {
  ["origami" /* ORIGAMI */]: "fold",
  ["hellraiser" /* HELLRAISER */]: "checkCall",
  ["commentator" /* COMMENTATOR */]: "raise"
};
function blockedBettingMove(holeCards) {
  for (const card of holeCards) {
    const blocked = card.special ? BLOCKS[card.special] : void 0;
    if (blocked) return blocked;
  }
  return null;
}
function activeBlockedMove(holeCards, phase) {
  return specialsTurnedOver(phase) ? blockedBettingMove(holeCards) : null;
}
function isActionBlocked(blocked, action, toCall, chips) {
  switch (blocked) {
    case "fold":
      return action === "fold" /* FOLD */;
    case "checkCall":
      return action === "check" /* CHECK */ || action === "call" /* CALL */;
    case "raise":
      return action === "bet" /* BET */ || action === "raise" /* RAISE */ || action === "all_in" /* ALL_IN */ && chips > toCall;
    default:
      return false;
  }
}

// src/engine/PlayerHand.ts
function withoutSpecials(cards) {
  return cards.map((card) => {
    if (!card.special) return card;
    const { special: _special, ...plain } = card;
    return plain;
  });
}
function playerLines(holeCards, specialEffects = true) {
  return specialEffects ? getShapeSetForPlayer(holeCards) : GRID_LINES;
}
function evaluatePlayerRankHand(holeCards, gridCards, specialEffects = true) {
  if (!specialEffects) {
    return HandEvaluator.evaluateBestGridHand(withoutSpecials(holeCards), gridCards, GRID_LINES);
  }
  const lines = getShapeSetForPlayer(holeCards);
  if (holeCards.some((c) => c.special === "snare" /* SNARE */)) {
    return HandEvaluator.evaluateBestGridHandWithSnare(holeCards, gridCards, lines);
  }
  if (holeCards.some((c) => c.special === "fray" /* FRAY */)) {
    return HandEvaluator.evaluateBestGridHandWithFray(holeCards, gridCards, lines);
  }
  return HandEvaluator.evaluateBestGridHand(holeCards, gridCards, lines);
}
function evaluatePlayerJewelHand(holeCards, gridCards, specialEffects = true) {
  if (!specialEffects) {
    return HandEvaluator.evaluateBestGridHandByJewel(withoutSpecials(holeCards), gridCards, GRID_LINES);
  }
  const lines = getShapeSetForPlayer(holeCards);
  if (holeCards.some((c) => c.special === "flawed" /* FLAWED */)) {
    return HandEvaluator.evaluateBestGridHandByJewelWithFlawed(holeCards, gridCards, lines);
  }
  return HandEvaluator.evaluateBestGridHandByJewel(holeCards, gridCards, lines);
}
var lineKey = (line) => [...line].sort((a, b) => a - b).join(",");
function sameLine(a, b) {
  return lineKey(a) === lineKey(b);
}
function lineTakenAway(axis, holeCards, gridCards, specialEffects = true) {
  if (!specialEffects) return null;
  const lines = getShapeSetForPlayer(holeCards);
  const has = (type) => holeCards.some((c) => c.special === type);
  try {
    if (axis === "rank") {
      if (has("snare" /* SNARE */)) return HandEvaluator.evaluateBestGridHand(holeCards, gridCards, lines).winningLine;
      if (has("fray" /* FRAY */)) return HandEvaluator.findBestFlushPotentialLine(holeCards, gridCards, lines);
    } else if (has("flawed" /* FLAWED */)) {
      return HandEvaluator.evaluateBestGridHandByJewel(holeCards, gridCards, lines).winningLine;
    }
  } catch {
  }
  return null;
}

// src/engine/GridPoker.ts
var GameEventType = /* @__PURE__ */ ((GameEventType2) => {
  GameEventType2["GAME_STARTED"] = "game_started";
  GameEventType2["HAND_STARTED"] = "hand_started";
  GameEventType2["ANTES_COLLECTED"] = "antes_collected";
  GameEventType2["CARDS_DEALT"] = "cards_dealt";
  GameEventType2["PHASE_CHANGED"] = "phase_changed";
  GameEventType2["PLAYER_ACTED"] = "player_acted";
  GameEventType2["BETTING_COMPLETE"] = "betting_complete";
  GameEventType2["SHOWDOWN"] = "showdown";
  GameEventType2["HAND_COMPLETE"] = "hand_complete";
  GameEventType2["PLAYER_ELIMINATED"] = "player_eliminated";
  return GameEventType2;
})(GameEventType || {});
var GridPoker = class {
  constructor(tableId, config = DEFAULT_GAME_CONFIG) {
    /** Players who left mid-hand — folded, and removed when the next hand starts. */
    this.pendingRemovals = /* @__PURE__ */ new Set();
    /** Index (in seat order) of this hand's opener — the "chip" holder, who opens every betting round of the hand. */
    this.handOpenerIndex = 0;
    /** Who held the chip last game (and their seat, in case they've since left) — null before the first game. */
    this.lastChip = null;
    this.phaseManager = new GamePhaseManager();
    this.table = this.initializeTable(tableId, config);
    this.deck = new Deck();
    this.bettingRound = new BettingRound(config.anteAmount);
    this.events = [];
    this.currentPlayerIndex = 0;
  }
  /**
   * Initialize table state
   */
  initializeTable(tableId, config) {
    return {
      id: tableId,
      name: `Table ${tableId}`,
      config,
      players: [],
      phase: this.phaseManager.getCurrentPhase(),
      dealerPosition: 1,
      currentPlayerIndex: 0,
      gridCards: [],
      pot: 0,
      currentBet: 0,
      minRaise: config.anteAmount,
      deck: [],
      handNumber: 0,
      createdAt: Date.now(),
      updatedAt: Date.now()
    };
  }
  /**
   * Add a player to the table
   */
  addPlayer(player) {
    if (this.table.players.length >= this.table.config.maxPlayers) {
      throw new Error(`Table is full (max ${this.table.config.maxPlayers} players)`);
    }
    if (this.table.players.some((p) => p.id === player.id)) {
      throw new Error(`Player ${player.id} is already at the table`);
    }
    const seated = {
      ...player,
      status: "waiting" /* WAITING */,
      currentBet: 0,
      totalBet: 0,
      cards: []
    };
    const insertAt = this.table.players.findIndex((p) => p.position > player.position);
    if (insertAt === -1) {
      this.table.players.push(seated);
    } else {
      this.table.players.splice(insertAt, 0, seated);
    }
    this.table.updatedAt = Date.now();
  }
  /** Whether this player is seated at the table (including one leaving at the end of this hand). */
  hasPlayer(playerId) {
    return this.table.players.some((p) => p.id === playerId);
  }
  /**
   * Remove a player from the table. Between hands they're removed at once.
   * During a hand, splicing them out would drop their bets from the side-pot
   * calculation and shift everyone's turn index, so instead they're folded
   * now (an all-in player stays in — their chips are already committed) and
   * removed when the next hand starts.
   */
  removePlayer(playerId) {
    const index = this.table.players.findIndex((p) => p.id === playerId);
    if (index === -1) {
      throw new Error(`Player ${playerId} not found at table`);
    }
    if (this.phaseManager.isCurrentPhaseBetting()) {
      this.pendingRemovals.add(playerId);
      this.table.players[index].isConnected = false;
      this.foldPlayer(playerId);
      return;
    }
    this.table.players.splice(index, 1);
    this.table.updatedAt = Date.now();
  }
  /**
   * Mark a player as connected or sitting out. A sitting-out player is not
   * dealt into later hands. Disconnecting during a hand also folds them, so
   * the table never waits on someone who isn't there.
   */
  setPlayerConnected(playerId, connected) {
    const player = this.table.players.find((p) => p.id === playerId);
    if (!player) {
      throw new Error(`Player ${playerId} not found at table`);
    }
    player.isConnected = connected;
    this.table.updatedAt = Date.now();
    if (!connected) {
      this.foldPlayer(playerId);
    }
  }
  /**
   * Fold a player whether or not it's their turn (leaving, timing out,
   * disconnecting). A no-op outside a betting round, or for a player who is
   * already folded or all-in.
   */
  foldPlayer(playerId) {
    const player = this.table.players.find((p) => p.id === playerId);
    if (!player) {
      throw new Error(`Player ${playerId} not found at table`);
    }
    if (!this.phaseManager.isCurrentPhaseBetting() || player.status !== "active" /* ACTIVE */) {
      return;
    }
    if (this.getCurrentPlayer()?.id === playerId) {
      this.processPlayerAction(playerId, "fold" /* FOLD */, void 0, { ignoreSpecialRestrictions: true });
      return;
    }
    player.status = "folded" /* FOLDED */;
    this.table.updatedAt = Date.now();
    this.emitEvent("player_acted" /* PLAYER_ACTED */, { playerId, action: "fold" /* FOLD */, amount: 0 });
    const contenders = this.table.players.filter(
      (p) => p.status === "active" /* ACTIVE */ || p.status === "all_in" /* ALL_IN */
    );
    if (contenders.length === 1 || this.bettingRound.isRoundComplete(this.table.players)) {
      this.completeBettingRound();
    }
  }
  /**
   * Top up a player's stack (a bot rebuy after busting to 0 — nothing else
   * ever replenishes a player's chips otherwise, and startHand() resets
   * every player back to ACTIVE regardless of stack size, so a busted
   * player would otherwise just auto-fold every ante forever). Does not
   * change status — the next startHand() call resets that itself.
   */
  addChips(playerId, amount) {
    const player = this.table.players.find((p) => p.id === playerId);
    if (!player) {
      throw new Error(`Player ${playerId} not found at table`);
    }
    player.chips += amount;
    this.table.updatedAt = Date.now();
  }
  /**
   * Start a new hand
   * @param qrngBytes - Optional QRNG bytes for shuffling
   */
  startHand(qrngBytes) {
    if (this.pendingRemovals.size > 0) {
      this.table.players = this.table.players.filter((p) => !this.pendingRemovals.has(p.id));
      this.pendingRemovals.clear();
    }
    const inPlay = this.table.players.filter((p) => this.isInPlay(p)).length;
    if (inPlay < this.table.config.minPlayers) {
      throw new Error(`Not enough players: need ${this.table.config.minPlayers}, have ${inPlay}`);
    }
    this.table.handNumber++;
    this.table.specialsKeptFaceDown = void 0;
    this.deck = createShuffledDeck(qrngBytes);
    this.phaseManager.reset();
    const gridCards = this.deck.dealCards(9);
    this.phaseManager.initializeGrid(gridCards);
    this.bettingRound = new BettingRound(this.table.config.anteAmount);
    this.table.players = this.table.players.map((p) => ({
      ...p,
      cards: [],
      status: p.isConnected ? "active" /* ACTIVE */ : "disconnected" /* DISCONNECTED */,
      currentBet: 0,
      totalBet: 0
    }));
    this.handOpenerIndex = this.nextChipHolderIndex();
    const holder = this.table.players[this.handOpenerIndex];
    this.lastChip = { playerId: holder.id, position: holder.position };
    this.table.dealerPosition = this.handOpenerIndex + 1;
    this.table.phase = this.phaseManager.getCurrentPhase();
    this.table.gridCards = this.phaseManager.getGridCards();
    this.table.pot = 0;
    this.table.currentBet = 0;
    this.table.deck = this.deck.getRemaining();
    this.table.winners = void 0;
    this.table.jewelWinners = void 0;
    this.table.showdownHands = void 0;
    this.table.showdownJewelHands = void 0;
    this.table.potResults = void 0;
    this.table.updatedAt = Date.now();
    this.emitEvent("hand_started" /* HAND_STARTED */, {
      handNumber: this.table.handNumber,
      qrngUsed: this.deck.wasQRNGUsed()
    });
    this.collectAntes();
  }
  /** Present and with chips to ante — i.e. will be dealt into the next hand. */
  isInPlay(player) {
    return player.isConnected && player.chips > 0;
  }
  /**
   * Index (in seat order) of the player who takes the chip this game: the
   * first player in play on the first game, otherwise the next player in
   * play after last game's holder. If that holder has since left, the
   * search carries on from where their seat was.
   */
  nextChipHolderIndex() {
    const players = this.table.players;
    const n = players.length;
    let from;
    if (!this.lastChip) {
      from = 0;
    } else {
      const stillHere = players.findIndex((p) => p.id === this.lastChip.playerId);
      if (stillHere !== -1) {
        from = (stillHere + 1) % n;
      } else {
        const after = players.findIndex((p) => p.position > this.lastChip.position);
        from = after === -1 ? 0 : after;
      }
    }
    for (let k = 0; k < n; k++) {
      const index = (from + k) % n;
      if (this.isInPlay(players[index])) return index;
    }
    return from;
  }
  /**
   * Collect antes from all players
   */
  collectAntes() {
    this.table.players = this.bettingRound.collectAntes(this.table.players);
    this.table.pot = this.bettingRound.getMainPot();
    this.emitEvent("antes_collected" /* ANTES_COLLECTED */, {
      totalAntes: this.table.pot
    });
    this.advanceToPreFlop();
  }
  /**
   * Advance to PRE_FLOP phase and deal hole cards
   */
  advanceToPreFlop() {
    const transition = this.phaseManager.advancePhase();
    this.table.phase = transition.currentPhase;
    const specialsDealt = /* @__PURE__ */ new Set();
    for (const player of this.table.players) {
      if (player.status === "active" /* ACTIVE */ || player.status === "all_in" /* ALL_IN */) {
        player.cards = this.deck.dealCards(HOLE_CARDS);
        dealSpecialCards(player.cards, void 0, {
          // Numerology/Suitor/Jeweler copy when the specials are turned over (ROUND_1).
          applyEffects: false,
          dealt: specialsDealt
        });
      }
    }
    this.table.deck = this.deck.getRemaining();
    this.emitEvent("cards_dealt" /* CARDS_DEALT */, {
      playersDealt: this.table.players.filter((p) => p.cards.length > 0).length
    });
    this.table.players.forEach((p) => {
      p.currentBet = 0;
    });
    this.startBettingRound();
  }
  /**
   * Open a fresh betting round. When at most one player can still act (the
   * rest are all-in or folded) there is nobody to bet against, so the round
   * completes immediately — which runs the board out to showdown via
   * completeBettingRound/advancePhase instead of asking a lone player to
   * check on their own every round.
   */
  startBettingRound() {
    this.bettingRound.resetForNewRound();
    const n = this.table.players.length;
    const opener = this.handOpenerIndex % n;
    const canAct = this.table.players.filter((p) => p.status === "active" /* ACTIVE */).length;
    if (canAct <= 1) {
      this.completeBettingRound();
      return;
    }
    this.currentPlayerIndex = (opener - 1 + n) % n;
    this.findNextActivePlayer();
  }
  /**
   * Process a player action
   */
  processPlayerAction(playerId, action, amount, { ignoreSpecialRestrictions = false } = {}) {
    if (!this.phaseManager.isCurrentPhaseBetting()) {
      throw new Error("No betting round in progress");
    }
    const player = this.table.players.find((p) => p.id === playerId);
    if (!player) {
      throw new Error(`Player ${playerId} not found`);
    }
    const currentPlayer = this.table.players[this.currentPlayerIndex];
    if (currentPlayer.id !== playerId) {
      throw new Error(`Not player's turn - current player is ${currentPlayer.id}`);
    }
    if (!ignoreSpecialRestrictions) {
      const blocked = this.blockedMoveFor(player);
      const toCall = Math.max(0, this.bettingRound.getCurrentBet() - (player.currentBet || 0));
      if (isActionBlocked(blocked, action, toCall, player.chips)) {
        throw new Error(`Your special card doesn't allow ${action} this hand`);
      }
    }
    const result = this.bettingRound.processAction(player, action, amount);
    if (!result.success) {
      throw new Error(result.error || "Action failed");
    }
    player.chips = result.newChipCount;
    player.status = result.newStatus;
    if (result.amountAdded > 0) {
      player.currentBet = (player.currentBet || 0) + result.amountAdded;
      player.totalBet = (player.totalBet || 0) + result.amountAdded;
      this.table.pot += result.amountAdded;
    }
    this.table.currentBet = this.bettingRound.getCurrentBet();
    this.table.updatedAt = Date.now();
    this.emitEvent("player_acted" /* PLAYER_ACTED */, {
      playerId,
      action,
      amount: result.amountAdded
    });
    if (player.chips === 0 && player.status === "folded" /* FOLDED */) {
      this.emitEvent("player_eliminated" /* PLAYER_ELIMINATED */, { playerId });
    }
    if (this.bettingRound.isRoundComplete(this.table.players)) {
      this.completeBettingRound();
    } else {
      this.findNextActivePlayer();
    }
  }
  /**
   * Complete current betting round and advance game
   */
  completeBettingRound() {
    this.emitEvent("betting_complete" /* BETTING_COMPLETE */, {
      pot: this.table.pot
    });
    const activePlayers = this.table.players.filter(
      (p) => p.status === "active" /* ACTIVE */ || p.status === "all_in" /* ALL_IN */
    );
    if (activePlayers.length === 1) {
      this.awardPotToPlayer(activePlayers[0].id);
      return;
    }
    if (this.phaseManager.getCurrentPhase() === "round_3" /* ROUND_3 */) {
      this.performShowdown();
    } else {
      this.advancePhase();
    }
  }
  /**
   * Advance to next game phase
   */
  advancePhase() {
    const transition = this.phaseManager.advancePhase();
    this.table.phase = transition.currentPhase;
    this.table.gridCards = this.phaseManager.getGridCards();
    this.resolveRevealTriggeredSpecials(transition.currentPhase);
    this.emitEvent("phase_changed" /* PHASE_CHANGED */, {
      from: transition.previousPhase,
      to: transition.currentPhase,
      revealedPositions: transition.revealedPositions
    });
    this.table.players.forEach((p) => {
      p.currentBet = 0;
    });
    this.startBettingRound();
  }
  /**
   * Stage 3 reveal-triggered specials (poker-app-spec.md Section 4.4 step 3),
   * fired right at the phase transition that reveals the board state each
   * one depends on:
   *  - corners -> ROUND_1: Seer privately sees the (still-hidden) center cell
   *  - diamond -> ROUND_2: Thief freezes its rank-only copy, per player
   *  - center -> ROUND_3: Impersonator duplicates the now-revealed center card;
   *    Limbo becomes the lowest card the (now complete) matrix doesn't have
   */
  resolveRevealTriggeredSpecials(phase) {
    if (phase === "round_1" /* ROUND_1 */) this.keepFoldedSpecialsFaceDown();
    if (!this.specialEffectsOn) return;
    const centerGridCard = this.table.gridCards.find((gc) => gc.position === 5);
    const faceDown = new Set(this.table.specialsKeptFaceDown ?? []);
    const holders = this.table.players.filter((p) => p.cards.length === HOLE_CARDS && !faceDown.has(p.id));
    if (phase === "round_1" /* ROUND_1 */) {
      for (const player of holders) {
        resolveInstantSpecials(player.cards);
      }
      if (centerGridCard) {
        resolveSeer(holders, centerGridCard);
        if (centerGridCard.privatelyVisibleTo) {
          this.phaseManager.setPrivatelyVisibleTo(5, centerGridCard.privatelyVisibleTo);
        }
      }
      return;
    }
    if (phase === "round_2" /* ROUND_2 */) {
      for (const player of holders) {
        resolveThief(player.cards, this.table.gridCards);
      }
      return;
    }
    if (phase === "round_3" /* ROUND_3 */) {
      if (!centerGridCard) return;
      for (const player of holders) {
        resolveImpersonator(player.cards, centerGridCard.card);
        resolveLimbo(player.cards, this.table.gridCards);
      }
    }
  }
  /**
   * TESTING ONLY (the server calls it only outside production, from
   * FORCE_SPECIAL): give `playerId`'s first hole card `special` for this
   * hand, and nothing else special on their hand — so one card's effect can
   * be checked on its own. Anyone else dealt the same special loses it (one
   * of each per hand). Only before the specials are turned over.
   */
  forceSpecialForTesting(playerId, special, second) {
    if (this.table.phase !== "pre_flop" /* PRE_FLOP */) {
      throw new Error("A special can only be forced before the specials are turned over");
    }
    const player = this.table.players.find((p) => p.id === playerId);
    if (!player || player.cards.length !== HOLE_CARDS) return;
    for (const other of this.table.players) {
      for (const card of other.cards) {
        if (card.special === special || second && card.special === second) delete card.special;
      }
    }
    delete player.cards[1].special;
    player.cards[0].special = special;
    if (second) player.cards[1].special = second;
  }
  /**
   * At the turn-over (or the hand's end, if that comes first): note everyone
   * who has already folded — their special stays face down to them.
   */
  keepFoldedSpecialsFaceDown() {
    if (this.table.specialsKeptFaceDown) return;
    this.table.specialsKeptFaceDown = this.table.players.filter((p) => p.status === "folded" /* FOLDED */).map((p) => p.id);
  }
  /** The betting move this player's special card rules out this hand, if any (none with effects off). */
  blockedMoveFor(player) {
    return this.specialEffectsOn ? activeBlockedMove(player.cards, this.table.phase) : null;
  }
  /** Whether special cards do anything at this table (see GameConfig.specialCardEffects). */
  get specialEffectsOn() {
    return this.table.config.specialCardEffects !== false;
  }
  /**
   * Perform showdown and determine winners.
   *
   * Split-pot Hi/Lo across two independent axes (poker-app-spec.md Section 3):
   * each pot divides into a rank half and a jewel half, each awarded to the
   * best hand on that axis among the pot's eligible players. A player can win
   * both halves. This mirrors the single-pot flow below it exactly, just run
   * twice — once per axis — against the same pots.
   */
  performShowdown() {
    this.keepFoldedSpecialsFaceDown();
    this.emitEvent("showdown" /* SHOWDOWN */);
    const revealedGridCards = this.phaseManager.getRevealedCards();
    const playerHands = [];
    const playerJewelHands = [];
    for (const player of this.table.players) {
      if (player.status === "active" /* ACTIVE */ || player.status === "all_in" /* ALL_IN */) {
        playerHands.push({
          playerId: player.id,
          hand: evaluatePlayerRankHand(player.cards, revealedGridCards, this.specialEffectsOn)
        });
        playerJewelHands.push({
          playerId: player.id,
          hand: evaluatePlayerJewelHand(player.cards, revealedGridCards, this.specialEffectsOn)
        });
      }
    }
    this.returnUncalledBet();
    const pots = this.bettingRound.calculatePots(this.table.players);
    const winners = [];
    const jewelWinners = [];
    const potResults = [];
    for (const pot of pots) {
      if (pot.amount === 0) continue;
      const potResult = {
        amount: pot.amount,
        eligiblePlayerIds: [...pot.eligiblePlayers],
        rankWinners: [],
        jewelWinners: []
      };
      potResults.push(potResult);
      const rankHalf = Math.ceil(pot.amount / 2);
      const jewelHalf = pot.amount - rankHalf;
      const eligibleHands = playerHands.filter((ph) => pot.eligiblePlayers.includes(ph.playerId));
      if (eligibleHands.length > 0) {
        const winnerIds = HandEvaluator.determineWinners(eligibleHands);
        const shares = this.splitChips(rankHalf, winnerIds);
        for (const winnerId of winnerIds) {
          const winnerHand = eligibleHands.find((h) => h.playerId === winnerId);
          const player = this.table.players.find((p) => p.id === winnerId);
          const shareAmount = shares.get(winnerId);
          player.chips += shareAmount;
          winners.push({
            playerId: winnerId,
            amount: shareAmount,
            handEvaluation: winnerHand.hand
          });
          potResult.rankWinners.push({ playerId: winnerId, amount: shareAmount, handName: winnerHand.hand.description ?? winnerHand.hand.name });
        }
      }
      const eligibleJewelHands = playerJewelHands.filter(
        (ph) => pot.eligiblePlayers.includes(ph.playerId)
      );
      if (eligibleJewelHands.length > 0) {
        const jewelWinnerIds = HandEvaluator.determineJewelWinners(eligibleJewelHands);
        const jewelShares = this.splitChips(jewelHalf, jewelWinnerIds);
        for (const winnerId of jewelWinnerIds) {
          const winnerHand = eligibleJewelHands.find((h) => h.playerId === winnerId);
          const player = this.table.players.find((p) => p.id === winnerId);
          const jewelShareAmount = jewelShares.get(winnerId);
          player.chips += jewelShareAmount;
          jewelWinners.push({
            playerId: winnerId,
            amount: jewelShareAmount,
            jewelHandEvaluation: winnerHand.hand
          });
          potResult.jewelWinners.push({ playerId: winnerId, amount: jewelShareAmount, handName: winnerHand.hand.description ?? winnerHand.hand.name });
        }
      }
    }
    this.table.winners = winners;
    this.table.jewelWinners = jewelWinners;
    this.table.potResults = potResults;
    this.table.showdownHands = playerHands.map((ph) => ({
      playerId: ph.playerId,
      handEvaluation: ph.hand
    }));
    this.table.showdownJewelHands = playerJewelHands.map((ph) => ({
      playerId: ph.playerId,
      jewelHandEvaluation: ph.hand
    }));
    this.phaseManager.advancePhase();
    this.table.phase = this.phaseManager.advancePhase().currentPhase;
    this.table.updatedAt = Date.now();
    this.emitEvent("hand_complete" /* HAND_COMPLETE */, {
      winners: winners.map((w) => ({
        playerId: w.playerId,
        amount: w.amount,
        hand: w.handEvaluation.name
      })),
      jewelWinners: jewelWinners.map((w) => ({
        playerId: w.playerId,
        amount: w.amount,
        hand: w.jewelHandEvaluation.name
      }))
    });
  }
  /**
   * Split `amount` evenly between winners. Chips that don't divide evenly go
   * one each to the winners earliest in this hand's turn order (starting
   * from its opener), so nothing is lost to rounding.
   */
  splitChips(amount, winnerIds) {
    const base = Math.floor(amount / winnerIds.length);
    let remainder = amount - base * winnerIds.length;
    const n = this.table.players.length;
    const openerIndex = this.table.dealerPosition - 1;
    const seatOrder = (id) => {
      const index = this.table.players.findIndex((p) => p.id === id);
      return (index - openerIndex + n) % n;
    };
    const shares = /* @__PURE__ */ new Map();
    for (const id of [...winnerIds].sort((a, b) => seatOrder(a) - seatOrder(b))) {
      shares.set(id, base + (remainder > 0 ? 1 : 0));
      if (remainder > 0) remainder--;
    }
    return shares;
  }
  /**
   * A bet nobody else matched (e.g. an all-in bigger than anyone could
   * call) was never really contested — hand the excess straight back to
   * whoever made it before the pot is paid out.
   */
  returnUncalledBet() {
    const byContribution = [...this.table.players].sort((a, b) => b.totalBet - a.totalBet);
    const [top, second] = byContribution;
    if (!top || !second || top.totalBet <= second.totalBet) return;
    const excess = top.totalBet - second.totalBet;
    top.chips += excess;
    top.totalBet -= excess;
    this.table.pot -= excess;
  }
  /**
   * Award entire pot to a single player (when all others fold)
   */
  awardPotToPlayer(playerId) {
    this.keepFoldedSpecialsFaceDown();
    const player = this.table.players.find((p) => p.id === playerId);
    if (!player) return;
    this.returnUncalledBet();
    player.chips += this.table.pot;
    this.table.potResults = [
      {
        amount: this.table.pot,
        eligiblePlayerIds: [playerId],
        rankWinners: [{ playerId, amount: this.table.pot, handName: "Won by default" }],
        jewelWinners: []
      }
    ];
    this.table.winners = [
      {
        playerId,
        amount: this.table.pot,
        handEvaluation: {
          ranking: 0,
          name: "Won by default",
          value: 0,
          cards: []
        }
      }
    ];
    this.phaseManager.setPhase("ended" /* ENDED */);
    this.table.phase = "ended" /* ENDED */;
    this.table.updatedAt = Date.now();
    this.emitEvent("hand_complete" /* HAND_COMPLETE */, {
      winners: [{ playerId, amount: this.table.pot }]
    });
  }
  /**
   * Find next active player
   */
  findNextActivePlayer() {
    const startIndex = this.currentPlayerIndex;
    let found = false;
    for (let i = 0; i < this.table.players.length; i++) {
      const index = (startIndex + i + 1) % this.table.players.length;
      const player = this.table.players[index];
      if (player.status === "active" /* ACTIVE */) {
        this.currentPlayerIndex = index;
        this.table.currentPlayerIndex = index;
        found = true;
        break;
      }
    }
    if (!found) {
      this.completeBettingRound();
    }
  }
  /**
   * Get current game state
   */
  /** The ante from the next hand on — a table's ante can rise hand by hand. */
  setAnteAmount(amount) {
    this.table.config = { ...this.table.config, anteAmount: amount };
  }
  getGameState() {
    return {
      ...this.table,
      // Cloned, not just this.table's own array reference — player fields
      // (chips, currentBet, status, cards) are mutated in place elsewhere
      // in this class (processPlayerAction, collectAntes, etc.), so a
      // snapshot holding the same objects would drift out from under any
      // caller diffing it against a later snapshot, same bug class as
      // GamePhaseManager.getGridCards() above.
      players: this.table.players.map((p) => ({ ...p, cards: [...p.cards] })),
      gridCards: this.phaseManager.getGridCards(),
      deck: this.deck.getRemaining(),
      currentBet: this.bettingRound.getCurrentBet(),
      minRaise: this.bettingRound.getMinRaise(),
      updatedAt: Date.now()
    };
  }
  /**
   * Get game events
   */
  getEvents() {
    return [...this.events];
  }
  /** This betting round's actions so far (the log resets every round). */
  getRoundActions() {
    return this.bettingRound.getActions();
  }
  /**
   * Get current player
   */
  getCurrentPlayer() {
    if (!this.phaseManager.isCurrentPhaseBetting()) return null;
    return this.table.players[this.currentPlayerIndex] || null;
  }
  /**
   * Emit a game event
   */
  emitEvent(type, data) {
    this.events.push({
      type,
      data,
      timestamp: Date.now()
    });
  }
  /**
   * Validate game state consistency
   */
  validateState() {
    const errors = [];
    if (this.table.players.length > PLAYERS_PER_TABLE) {
      errors.push(`Too many players: ${this.table.players.length}`);
    }
    if (this.table.gridCards.length !== 9 && this.table.gridCards.length !== 0) {
      errors.push(`Invalid grid card count: ${this.table.gridCards.length}`);
    }
    if (this.table.pot < 0) {
      errors.push(`Negative pot: ${this.table.pot}`);
    }
    for (const player of this.table.players) {
      if (player.chips < 0) {
        errors.push(`Player ${player.id} has negative chips: ${player.chips}`);
      }
    }
    return {
      valid: errors.length === 0,
      errors
    };
  }
};

// src/engine/ViewerState.ts
var SHOWDOWN_PHASES = ["showdown" /* SHOWDOWN */, "ended" /* ENDED */];
var INSIGHT_PHASES = ["round_2" /* ROUND_2 */, "round_3" /* ROUND_3 */, ...SHOWDOWN_PHASES];
function getViewerFacingTable(table, viewerId) {
  const effectsOn = table.config.specialCardEffects !== false;
  const viewer = table.players.find((p) => p.id === viewerId);
  const faceDown = new Set(table.specialsKeptFaceDown ?? []);
  const insight = effectsOn && viewer && !faceDown.has(viewer.id) && INSIGHT_PHASES.includes(table.phase) ? insightCardOf(viewer.cards) : null;
  const nonFoldedPlayers = table.players.filter((p) => p.status !== "folded" /* FOLDED */);
  const isRealShowdown = SHOWDOWN_PHASES.includes(table.phase) && nonFoldedPlayers.length > 1;
  const players = table.players.map((player) => {
    let cards;
    if (player.id === viewerId) {
      cards = holderView(player.cards, table.phase, effectsOn, faceDown.has(player.id));
    } else if (isRealShowdown && player.status !== "folded" /* FOLDED */) {
      cards = player.cards;
    } else if (insight) {
      cards = getInsightView(insight, player.cards);
    } else {
      cards = player.cards.map(() => ({ hidden: true }));
    }
    return {
      id: player.id,
      name: player.name,
      chips: player.chips,
      position: player.position,
      status: player.status,
      currentBet: player.currentBet,
      totalBet: player.totalBet,
      avatar: player.avatar,
      isConnected: player.isConnected,
      cards
    };
  });
  const gridCards = table.gridCards.map((gridCard) => {
    const privatelyVisible = gridCard.privatelyVisibleTo?.includes(viewerId) ?? false;
    const canSee = gridCard.revealed || privatelyVisible;
    return {
      position: gridCard.position,
      revealed: gridCard.revealed,
      card: canSee ? gridCard.card : void 0
    };
  });
  return {
    id: table.id,
    name: table.name,
    phase: table.phase,
    dealerPosition: table.dealerPosition,
    currentPlayerIndex: table.currentPlayerIndex,
    pot: table.pot,
    currentBet: table.currentBet,
    minRaise: table.minRaise,
    handNumber: table.handNumber,
    players,
    gridCards,
    winners: table.winners,
    jewelWinners: table.jewelWinners,
    showdownHands: table.showdownHands,
    showdownJewelHands: table.showdownJewelHands,
    potResults: table.potResults
  };
}
function privateRevealHolderIds(table) {
  const effectsOn = table.config.specialCardEffects !== false;
  const holds = (cards, ...types) => cards.some((card) => !!card.special && types.includes(card.special));
  const triggered = (cards) => table.phase === "round_1" /* ROUND_1 */ ? cards.some((card) => !!card.special) : table.phase === "round_2" /* ROUND_2 */ ? effectsOn && (insightCardOf(cards) !== null || holds(cards, "thief" /* THIEF */)) : table.phase === "round_3" /* ROUND_3 */ ? effectsOn && holds(cards, "impersonator" /* IMPERSONATOR */, "limbo" /* LIMBO */) : false;
  const faceDown = new Set(table.specialsKeptFaceDown ?? []);
  return table.players.filter((p) => !faceDown.has(p.id) && triggered(p.cards)).map((p) => p.id);
}
function isHiddenCard(card) {
  return "hidden" in card;
}
function isMaskedCard(card) {
  return "masked" in card;
}
function isRealCard(card) {
  return !("hidden" in card) && !("masked" in card);
}
function specialsOf(cards) {
  return cards.flatMap((card) => card && !isMaskedCard(card) && card.special ? [card.special] : []);
}

// src/engine/NextCard.ts
var POSITIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9];
function resolveForView(holeCards, grid, effectsOn = true) {
  const cards = holeCards.map((card) => ({ ...card }));
  if (!effectsOn || cards.length !== 2) return cards;
  const centre = grid.find((gc) => gc.position === 5 && gc.card);
  if (centre) resolveImpersonator(cards, centre.card);
  if (grid.length === 9 && grid.every((gc) => gc.card) && cards.some((c) => c.special === "limbo" /* LIMBO */)) resolveLimbo(cards, grid);
  return cards;
}
function score(axis, holeCards, grid, effectsOn) {
  const cards = resolveForView(holeCards, grid, effectsOn);
  try {
    return axis === "rank" ? evaluatePlayerRankHand(cards, grid, effectsOn) : evaluatePlayerJewelHand(cards, grid, effectsOn);
  } catch {
    return null;
  }
}
var better = (axis, a, b) => axis === "rank" ? HandEvaluator.compareHands(a, b) > 0 : HandEvaluator.compareJewelHands(a, b) > 0;
function candidateCards(axis, visibleCards) {
  const used = new Set(visibleCards.map((c) => `${c.rank}-${c.suit}`));
  const candidates = [];
  for (const rank of Object.values(Rank)) {
    const suits = Object.values(Suit).filter((s) => !used.has(`${rank}-${s}`));
    if (axis === "rank") {
      for (const suit of suits) candidates.push({ rank, suit, jewel: "ruby" /* RUBY */, id: `try-${rank}-${suit}` });
    } else if (suits.length > 0) {
      for (const jewel of Object.values(Jewel)) candidates.push({ rank, suit: suits[0], jewel, id: `try-${rank}-${jewel}` });
    }
  }
  return candidates;
}
function nextCardAdvice(axis, holeCards, knownGrid, visibleCards, effectsOn = true) {
  const current = score(axis, holeCards, knownGrid, effectsOn);
  const known = new Set(knownGrid.map((gc) => gc.position));
  const hidden = POSITIONS.filter((p) => !known.has(p));
  const candidates = candidateCards(axis, visibleCards);
  let best = null;
  for (const position of hidden) {
    for (const card of candidates) {
      const grid = [...knownGrid, { position, card, revealed: true }];
      const hand = score(axis, holeCards, grid, effectsOn);
      if (!hand) continue;
      if (current && !better(axis, hand, current)) continue;
      if (!best || better(axis, hand, best.hand)) best = { position, card, hand };
    }
  }
  return { current, unknownCells: hidden.length, best };
}
function lineOverview(axis, holeCards, knownGrid, visibleCards, effectsOn = true) {
  const allowed = playerLines(holeCards, effectsOn);
  const plain = effectsOn ? holeCards : withoutSpecials(holeCards);
  const lineHand = (cards, grid, line) => {
    try {
      return axis === "rank" ? HandEvaluator.evaluateBestGridHand(cards, grid, [line]) : HandEvaluator.evaluateBestGridHandByJewel(cards, grid, [line]);
    } catch {
      return null;
    }
  };
  const taken = (cards, grid) => lineTakenAway(axis, cards, grid, effectsOn);
  const cardsNow = resolveForView(plain, knownGrid, effectsOn);
  const takenNow = taken(cardsNow, knownGrid);
  const known = new Map(knownGrid.map((gc) => [gc.position, gc]));
  const lastCell = knownGrid.length === POSITIONS.length - 1;
  let candidates = null;
  return GRID_LINES.map((line) => {
    const row = {
      line: [...line],
      inPlay: allowed.some((l) => sameLine(l, line)),
      knownCells: line.filter((p) => known.has(p)).length,
      hand: null,
      takenAway: false,
      best: null,
      wouldBeTakenAway: false
    };
    if (!row.inPlay) return row;
    if (row.knownCells === 3) {
      row.hand = lineHand(cardsNow, knownGrid, row.line);
      row.takenAway = !!takenNow && sameLine(takenNow, line);
    } else if (row.knownCells === 2) {
      const position = line.find((p) => !known.has(p));
      candidates ?? (candidates = candidateCards(axis, visibleCards));
      let completions = 0;
      for (const card of candidates) {
        const grid = [...knownGrid, { position, card, revealed: true }];
        const cards = resolveForView(plain, grid, effectsOn);
        const hand = lineHand(cards, grid, row.line);
        if (!hand) continue;
        completions++;
        if (lastCell) {
          const t = taken(cards, grid);
          if (t && sameLine(t, line)) continue;
        }
        if (!row.best || better(axis, hand, row.best.hand)) row.best = { position, card, hand };
      }
      row.wouldBeTakenAway = completions > 0 && !row.best;
    }
    return row;
  });
}

// src/qrng/config.ts
var DEFAULT_QRNG_CONFIG = {
  // ANU QRNG API endpoint
  apiUrl: "https://qrng.anu.edu.au/API/jsonI.php",
  // No API key needed for free tier
  apiKey: void 0,
  // Fetch 1024 bytes per request (free tier max)
  // This gives us enough for ~19 shuffles (52 bytes each)
  blockSize: 1024,
  // Retry configuration
  maxRetries: 3,
  retryDelay: 1e3,
  // Start with 1 second
  timeout: 1e4,
  // 10 second timeout
  // Cache configuration
  cacheTTL: 36e5,
  // 1 hour
  minCacheSize: 5,
  // Minimum 5 byte arrays in cache
  // Monitoring
  enableMetrics: true,
  enableValidation: true,
  chiSquaredAlpha: 0.05
  // 5% significance level
};
var createMetrics = () => ({
  totalRequests: 0,
  successfulFetches: 0,
  failedFetches: 0,
  csprngFallbacks: 0,
  totalQRNGBytes: 0,
  totalCSPRNGBytes: 0,
  cacheHits: 0,
  cacheMisses: 0,
  avgResponseTime: 0,
  failedValidations: 0,
  lastFetchTime: 0
});
var QRNGErrorType = /* @__PURE__ */ ((QRNGErrorType2) => {
  QRNGErrorType2["NETWORK_ERROR"] = "network_error";
  QRNGErrorType2["API_ERROR"] = "api_error";
  QRNGErrorType2["TIMEOUT"] = "timeout";
  QRNGErrorType2["INVALID_RESPONSE"] = "invalid_response";
  QRNGErrorType2["RATE_LIMIT"] = "rate_limit";
  QRNGErrorType2["VALIDATION_FAILED"] = "validation_failed";
  QRNGErrorType2["SHUFFLE_ERROR"] = "shuffle_error";
  return QRNGErrorType2;
})(QRNGErrorType || {});
var QRNGError = class extends Error {
  constructor(type, message, originalError) {
    super(message);
    this.type = type;
    this.originalError = originalError;
    this.name = "QRNGError";
  }
};

// src/qrng/QRNGClient.ts
var QRNGClient = class {
  // Min 100ms between requests
  constructor(config, httpClient) {
    this.config = config;
    this.lastRequestTime = 0;
    this.minRequestInterval = 100;
    this.metrics = createMetrics();
    this.httpClient = httpClient;
  }
  /**
   * Fetch random bytes from ANU QRNG API
   * @param length - Number of bytes to fetch, at most config.blockSize (the
   * API's per-request limit — callers needing more fetch in blocks, as
   * ShuffleService does)
   * @returns Array of random bytes (0-255)
   */
  async fetchRandomBytes(length) {
    if (!Number.isInteger(length) || length <= 0) {
      throw new QRNGError("invalid_response" /* INVALID_RESPONSE */, `Length must be positive (got ${length})`);
    }
    if (length > this.config.blockSize) {
      throw new QRNGError(
        "invalid_response" /* INVALID_RESPONSE */,
        `Length ${length} exceeds maximum block size of ${this.config.blockSize}`
      );
    }
    this.metrics.totalRequests++;
    const startTime = Date.now();
    let lastError;
    for (let attempt = 0; attempt <= this.config.maxRetries; attempt++) {
      try {
        await this.enforceRateLimit();
        const data = await this.makeRequest(length);
        this.updateMetricsOnSuccess(startTime, data.length);
        return data;
      } catch (error) {
        lastError = error;
        if (attempt < this.config.maxRetries && this.shouldRetry(error)) {
          const delay = this.calculateRetryDelay(attempt);
          await this.sleep(delay);
          continue;
        }
        break;
      }
    }
    this.updateMetricsOnFailure(lastError);
    throw new QRNGError(
      "api_error" /* API_ERROR */,
      `Failed to fetch random bytes after ${this.config.maxRetries + 1} attempts`,
      lastError
    );
  }
  /**
   * Make the actual API request
   */
  async makeRequest(length) {
    const url = this.buildUrl(length);
    try {
      let response;
      if (this.httpClient) {
        response = await this.httpClient.get(url, {
          timeout: this.config.timeout
        });
      } else {
        const fetchResponse = await this.fetchWithTimeout(url, this.config.timeout);
        if (!fetchResponse.ok) {
          throw new QRNGError(
            "api_error" /* API_ERROR */,
            `HTTP ${fetchResponse.status}: ${fetchResponse.statusText}`
          );
        }
        response = { data: await fetchResponse.json() };
      }
      this.validateResponse(response.data);
      return response.data.data;
    } catch (error) {
      if (error instanceof QRNGError) {
        throw error;
      }
      const errorMessage = error.message || "Unknown error";
      if (errorMessage.includes("timeout") || errorMessage.includes("ETIMEDOUT")) {
        throw new QRNGError("timeout" /* TIMEOUT */, "Request timeout", error);
      }
      if (errorMessage.includes("429") || errorMessage.includes("rate limit")) {
        throw new QRNGError("rate_limit" /* RATE_LIMIT */, "Rate limit exceeded", error);
      }
      throw new QRNGError("network_error" /* NETWORK_ERROR */, errorMessage, error);
    }
  }
  /**
   * Build API URL with query parameters
   */
  buildUrl(length) {
    const params = new URLSearchParams({
      length: length.toString(),
      type: "uint8"
    });
    return `${this.config.apiUrl}?${params.toString()}`;
  }
  /**
   * Validate API response
   */
  validateResponse(response) {
    if (!response.success) {
      throw new QRNGError(
        "invalid_response" /* INVALID_RESPONSE */,
        "API returned success=false"
      );
    }
    if (!Array.isArray(response.data)) {
      throw new QRNGError(
        "invalid_response" /* INVALID_RESPONSE */,
        "Response data is not an array"
      );
    }
    if (response.data.length !== response.length) {
      throw new QRNGError(
        "invalid_response" /* INVALID_RESPONSE */,
        `Expected ${response.length} bytes, got ${response.data.length}`
      );
    }
    for (const byte of response.data) {
      if (!Number.isInteger(byte) || byte < 0 || byte > 255) {
        throw new QRNGError(
          "invalid_response" /* INVALID_RESPONSE */,
          `Invalid byte value: ${byte}`
        );
      }
    }
  }
  /**
   * Fetch with timeout using AbortController
   */
  async fetchWithTimeout(url, timeout) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);
    try {
      const response = await fetch(url, {
        signal: controller.signal
      });
      clearTimeout(timeoutId);
      return response;
    } catch (error) {
      clearTimeout(timeoutId);
      throw error;
    }
  }
  /**
   * Enforce rate limiting between requests
   */
  async enforceRateLimit() {
    const now = Date.now();
    const timeSinceLastRequest = now - this.lastRequestTime;
    if (timeSinceLastRequest < this.minRequestInterval) {
      await this.sleep(this.minRequestInterval - timeSinceLastRequest);
    }
    this.lastRequestTime = Date.now();
  }
  /**
   * Calculate exponential backoff delay
   */
  calculateRetryDelay(attempt) {
    const baseDelay = this.config.retryDelay;
    const exponentialDelay = baseDelay * Math.pow(2, attempt);
    const jitter = Math.random() * 1e3;
    return Math.min(exponentialDelay + jitter, 3e4);
  }
  /**
   * Determine if error is retryable
   */
  shouldRetry(error) {
    if (error.type === "invalid_response" /* INVALID_RESPONSE */) {
      return false;
    }
    return [
      "network_error" /* NETWORK_ERROR */,
      "timeout" /* TIMEOUT */,
      "api_error" /* API_ERROR */,
      "rate_limit" /* RATE_LIMIT */
    ].includes(error.type);
  }
  /**
   * Update metrics on successful fetch
   */
  updateMetricsOnSuccess(startTime, bytesReceived) {
    const responseTime = Date.now() - startTime;
    this.metrics.successfulFetches++;
    this.metrics.totalQRNGBytes += bytesReceived;
    this.metrics.lastFetchTime = Date.now();
    const totalFetches = this.metrics.successfulFetches;
    this.metrics.avgResponseTime = (this.metrics.avgResponseTime * (totalFetches - 1) + responseTime) / totalFetches;
  }
  /**
   * Update metrics on failed fetch
   */
  updateMetricsOnFailure(error) {
    this.metrics.failedFetches++;
    this.metrics.lastError = error?.message;
  }
  /**
   * Get current metrics
   */
  getMetrics() {
    return { ...this.metrics };
  }
  /**
   * Reset metrics
   */
  resetMetrics() {
    this.metrics = createMetrics();
  }
  /**
   * Sleep utility
   */
  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  /**
   * Test connection to QRNG API
   */
  async testConnection() {
    try {
      await this.fetchRandomBytes(10);
      return true;
    } catch {
      return false;
    }
  }
  /**
   * Get API health status
   */
  async getHealthStatus() {
    const startTime = Date.now();
    try {
      await this.fetchRandomBytes(10);
      const responseTime = Date.now() - startTime;
      return {
        healthy: true,
        responseTime
      };
    } catch (error) {
      return {
        healthy: false,
        error: error.message
      };
    }
  }
};

// src/qrng/RandomnessValidator.ts
var RandomnessValidator = class {
  /**
   * Chi-squared test for uniform distribution
   * Tests if bytes are uniformly distributed across all 256 possible values
   *
   * @param bytes - Array of random bytes to test
   * @param alpha - Significance level (typically 0.05)
   * @returns Validation result
   */
  static chiSquaredTest(bytes, alpha = 0.05) {
    if (bytes.length === 0) {
      return {
        passed: false,
        testName: "Chi-Squared Test",
        statistic: 0,
        pValue: 0,
        threshold: 0,
        details: "No data provided"
      };
    }
    const observed = new Array(256).fill(0);
    for (const byte of bytes) {
      if (byte >= 0 && byte <= 255) {
        observed[byte]++;
      }
    }
    const expected = bytes.length / 256;
    let chiSquared = 0;
    for (let i = 0; i < 256; i++) {
      const diff = observed[i] - expected;
      chiSquared += diff * diff / expected;
    }
    const degreesOfFreedom = 255;
    const criticalValue = this.chiSquaredCriticalValue(degreesOfFreedom, alpha);
    const pValue = this.chiSquaredPValue(chiSquared, degreesOfFreedom);
    const passed = chiSquared < criticalValue;
    return {
      passed,
      testName: "Chi-Squared Test",
      statistic: chiSquared,
      pValue,
      threshold: criticalValue,
      details: passed ? "Distribution appears uniform" : "Distribution may not be uniform"
    };
  }
  /**
   * Runs test - test for independence of consecutive values
   * Tests if consecutive bytes are independent
   *
   * @param bytes - Array of random bytes
   * @param alpha - Significance level
   * @returns Validation result
   */
  static runsTest(bytes, alpha = 0.05) {
    if (bytes.length < 2) {
      return {
        passed: false,
        testName: "Runs Test",
        statistic: 0,
        pValue: 0,
        threshold: 0,
        details: "Insufficient data"
      };
    }
    const median = this.calculateMedian(bytes);
    const binary = bytes.map((b) => b >= median ? 1 : 0);
    let runs = 1;
    for (let i = 1; i < binary.length; i++) {
      if (binary[i] !== binary[i - 1]) {
        runs++;
      }
    }
    const ones = binary.filter((b) => b === 1).length;
    const zeros = binary.length - ones;
    const expectedRuns = 2 * ones * zeros / binary.length + 1;
    const variance = 2 * ones * zeros * (2 * ones * zeros - binary.length) / (binary.length * binary.length * (binary.length - 1));
    const zScore = (runs - expectedRuns) / Math.sqrt(variance);
    const criticalZ = this.normalCriticalValue(alpha / 2);
    const passed = Math.abs(zScore) < criticalZ;
    const pValue = 2 * (1 - this.normalCDF(Math.abs(zScore)));
    return {
      passed,
      testName: "Runs Test",
      statistic: zScore,
      pValue,
      threshold: criticalZ,
      details: passed ? "Values appear independent" : "Values may not be independent"
    };
  }
  /**
   * Serial test - test for correlation between bytes at different positions
   *
   * @param bytes - Array of random bytes
   * @param lag - Distance between positions to test (default 1)
   * @param alpha - Significance level
   * @returns Validation result
   */
  static serialTest(bytes, lag = 1, _alpha = 0.05) {
    if (bytes.length < lag + 1) {
      return {
        passed: false,
        testName: "Serial Test",
        statistic: 0,
        pValue: 0,
        threshold: 0,
        details: "Insufficient data for lag=" + lag
      };
    }
    const n = bytes.length - lag;
    let sumX = 0, sumY = 0, sumXY = 0, sumX2 = 0, sumY2 = 0;
    for (let i = 0; i < n; i++) {
      const x = bytes[i];
      const y = bytes[i + lag];
      sumX += x;
      sumY += y;
      sumXY += x * y;
      sumX2 += x * x;
      sumY2 += y * y;
    }
    const correlation = (n * sumXY - sumX * sumY) / Math.sqrt((n * sumX2 - sumX * sumX) * (n * sumY2 - sumY * sumY));
    const testStat = correlation * Math.sqrt(n - 2) / Math.sqrt(1 - correlation * correlation);
    const criticalValue = 1.96;
    const passed = Math.abs(testStat) < criticalValue;
    const pValue = 2 * (1 - this.normalCDF(Math.abs(testStat)));
    return {
      passed,
      testName: `Serial Test (lag=${lag})`,
      statistic: testStat,
      pValue,
      threshold: criticalValue,
      details: passed ? "No significant correlation detected" : "Correlation may be present"
    };
  }
  /**
   * Run all validation tests
   *
   * @param bytes - Array of random bytes
   * @param alpha - Significance level
   * @returns Array of validation results
   */
  static runAllTests(bytes, alpha = 0.05) {
    return [
      this.chiSquaredTest(bytes, alpha),
      this.runsTest(bytes, alpha),
      this.serialTest(bytes, 1, alpha),
      this.serialTest(bytes, 2, alpha)
    ];
  }
  /**
   * Check if all tests passed
   */
  static allTestsPassed(results) {
    return results.every((r) => r.passed);
  }
  // ============================================================================
  // Statistical Helper Functions
  // ============================================================================
  /**
   * Approximate chi-squared critical value using Wilson-Hilferty transformation
   */
  static chiSquaredCriticalValue(df, alpha) {
    const z5 = this.normalCriticalValue(alpha);
    const term1 = 1 - 2 / (9 * df);
    const term2 = z5 * Math.sqrt(2 / (9 * df));
    return df * Math.pow(term1 + term2, 3);
  }
  /**
   * Approximate chi-squared p-value
   */
  static chiSquaredPValue(chiSquared, df) {
    const z5 = (Math.pow(chiSquared / df, 1 / 3) - (1 - 2 / (9 * df))) / Math.sqrt(2 / (9 * df));
    return 1 - this.normalCDF(z5);
  }
  /**
   * Normal distribution critical value (z-score)
   */
  static normalCriticalValue(alpha) {
    if (alpha >= 0.05) return 1.96;
    if (alpha >= 0.01) return 2.576;
    if (alpha >= 1e-3) return 3.291;
    return 3.891;
  }
  /**
   * Standard normal cumulative distribution function (CDF)
   * Using approximation formula
   */
  static normalCDF(z5) {
    const t = 1 / (1 + 0.2316419 * Math.abs(z5));
    const d = 0.3989423 * Math.exp(-z5 * z5 / 2);
    const prob = d * t * (0.3193815 + t * (-0.3565638 + t * (1.781478 + t * (-1.821256 + t * 1.330274))));
    return z5 > 0 ? 1 - prob : prob;
  }
  /**
   * Calculate median of array
   */
  static calculateMedian(arr) {
    const sorted = [...arr].sort((a, b) => a - b);
    const mid = Math.floor(sorted.length / 2);
    if (sorted.length % 2 === 0) {
      return (sorted[mid - 1] + sorted[mid]) / 2;
    }
    return sorted[mid];
  }
  /**
   * Calculate entropy (information content)
   * Higher entropy = more random
   *
   * @param bytes - Array of bytes
   * @returns Entropy in bits (max 8.0 for perfect randomness)
   */
  static calculateEntropy(bytes) {
    if (bytes.length === 0) return 0;
    const freq = /* @__PURE__ */ new Map();
    for (const byte of bytes) {
      freq.set(byte, (freq.get(byte) || 0) + 1);
    }
    let entropy = 0;
    const total = bytes.length;
    for (const count of freq.values()) {
      const p = count / total;
      entropy -= p * Math.log2(p);
    }
    return entropy;
  }
  /**
   * Generate validation report
   */
  static generateReport(bytes, alpha = 0.05) {
    const results = this.runAllTests(bytes, alpha);
    const entropy = this.calculateEntropy(bytes);
    const allPassed = this.allTestsPassed(results);
    let report = "=== Randomness Validation Report ===\n\n";
    report += `Sample Size: ${bytes.length} bytes
`;
    report += `Entropy: ${entropy.toFixed(4)} bits (max: 8.0)
`;
    report += `Significance Level (\u03B1): ${alpha}
`;
    report += `Overall Result: ${allPassed ? "PASSED \u2713" : "FAILED \u2717"}

`;
    for (const result of results) {
      report += `--- ${result.testName} ---
`;
      report += `  Status: ${result.passed ? "PASSED \u2713" : "FAILED \u2717"}
`;
      report += `  Statistic: ${result.statistic.toFixed(4)}
`;
      report += `  P-Value: ${result.pValue.toFixed(4)}
`;
      report += `  Threshold: ${result.threshold.toFixed(4)}
`;
      report += `  Details: ${result.details}

`;
    }
    return report;
  }
};

// src/qrng/cache/MemoryCache.ts
var MemoryCache = class {
  constructor(options) {
    this.cache = [];
    this.hits = 0;
    this.misses = 0;
    this.ttl = options.ttl;
    this.maxEntries = options.maxEntries;
  }
  /**
   * Get bytes from cache
   */
  async get(length) {
    await this.cleanup();
    for (let i = 0; i < this.cache.length; i++) {
      const entry = this.cache[i];
      if (entry.bytes.length >= length) {
        const bytes = entry.bytes.slice(0, length);
        entry.bytes = entry.bytes.slice(length);
        if (entry.bytes.length === 0) {
          this.cache.splice(i, 1);
        }
        this.hits++;
        return bytes;
      }
    }
    this.misses++;
    return null;
  }
  /**
   * Add bytes to cache
   */
  async set(bytes, validated) {
    if (bytes.length === 0) {
      return;
    }
    this.cache.push({
      bytes,
      timestamp: Date.now(),
      validated
    });
    if (this.cache.length > this.maxEntries) {
      this.cache.shift();
    }
  }
  /**
   * Clear all cached bytes
   */
  async clear() {
    this.cache.length = 0;
    this.hits = 0;
    this.misses = 0;
  }
  /**
   * Get cache statistics
   */
  async getStats() {
    return {
      entries: this.cache.length,
      totalBytes: this.cache.reduce((sum, entry) => sum + entry.bytes.length, 0),
      hits: this.hits,
      misses: this.misses,
      oldestTimestamp: this.cache.length > 0 ? this.cache[0].timestamp : null
    };
  }
  /**
   * Remove expired entries
   */
  async cleanup() {
    const now = Date.now();
    let i = 0;
    while (i < this.cache.length) {
      if (now - this.cache[i].timestamp > this.ttl) {
        this.cache.splice(i, 1);
      } else {
        i++;
      }
    }
  }
  /**
   * Close cache connection (no-op for memory cache)
   */
  async close() {
  }
};

// src/qrng/cache/RedisCache.ts
var RedisCache = class {
  constructor(client, options) {
    this.client = client;
    this.ttl = options.ttl;
    this.keyPrefix = options.keyPrefix;
    this.statsKey = `${this.keyPrefix}:stats`;
  }
  /**
   * Get bytes from cache
   */
  async get(length) {
    try {
      const keys = await this.client.keys(`${this.keyPrefix}:entry:*`);
      if (keys.length === 0) {
        await this.incrementMiss();
        return null;
      }
      keys.sort();
      for (const key of keys) {
        const data = await this.client.get(key);
        if (!data) continue;
        const entry = JSON.parse(data);
        if (entry.bytes.length >= length) {
          const bytes = entry.bytes.slice(0, length);
          const remaining = entry.bytes.slice(length);
          if (remaining.length > 0) {
            entry.bytes = remaining;
            await this.client.set(key, JSON.stringify(entry), this.ttl);
          } else {
            await this.client.del(key);
          }
          await this.incrementHit();
          return bytes;
        }
      }
      await this.incrementMiss();
      return null;
    } catch (error) {
      console.error("Redis cache get error:", error);
      await this.incrementMiss();
      return null;
    }
  }
  /**
   * Add bytes to cache
   */
  async set(bytes, validated) {
    if (bytes.length === 0) {
      return;
    }
    try {
      const entry = {
        bytes,
        timestamp: Date.now(),
        validated
      };
      const key = `${this.keyPrefix}:entry:${Date.now()}:${Math.random()}`;
      await this.client.set(key, JSON.stringify(entry), this.ttl);
    } catch (error) {
      console.error("Redis cache set error:", error);
    }
  }
  /**
   * Clear all cached bytes
   */
  async clear() {
    try {
      const keys = await this.client.keys(`${this.keyPrefix}:*`);
      for (const key of keys) {
        await this.client.del(key);
      }
    } catch (error) {
      console.error("Redis cache clear error:", error);
    }
  }
  /**
   * Get cache statistics
   */
  async getStats() {
    try {
      const keys = await this.client.keys(`${this.keyPrefix}:entry:*`);
      let totalBytes = 0;
      let oldestTimestamp = null;
      for (const key of keys) {
        const data = await this.client.get(key);
        if (!data) continue;
        const entry = JSON.parse(data);
        totalBytes += entry.bytes.length;
        if (oldestTimestamp === null || entry.timestamp < oldestTimestamp) {
          oldestTimestamp = entry.timestamp;
        }
      }
      const hitsStr = await this.client.get(`${this.statsKey}:hits`);
      const missesStr = await this.client.get(`${this.statsKey}:misses`);
      return {
        entries: keys.length,
        totalBytes,
        hits: hitsStr ? parseInt(hitsStr, 10) : 0,
        misses: missesStr ? parseInt(missesStr, 10) : 0,
        oldestTimestamp
      };
    } catch (error) {
      console.error("Redis cache getStats error:", error);
      return {
        entries: 0,
        totalBytes: 0,
        hits: 0,
        misses: 0,
        oldestTimestamp: null
      };
    }
  }
  /**
   * Remove expired entries (handled automatically by Redis TTL)
   */
  async cleanup() {
  }
  /**
   * Close cache connection
   */
  async close() {
    try {
      await this.client.quit();
    } catch (error) {
      console.error("Redis cache close error:", error);
    }
  }
  /**
   * Increment cache hit counter
   */
  async incrementHit() {
    try {
      await this.client.incr(`${this.statsKey}:hits`);
    } catch (error) {
    }
  }
  /**
   * Increment cache miss counter
   */
  async incrementMiss() {
    try {
      await this.client.incr(`${this.statsKey}:misses`);
    } catch (error) {
    }
  }
};
function createRedisCache(client, options) {
  return new RedisCache(client, options);
}

// src/qrng/ShuffleService.ts
var ShuffleService = class {
  constructor(options = {}) {
    this.metrics = {
      totalShuffles: 0,
      qrngShuffles: 0,
      csprngShuffles: 0,
      cacheHits: 0,
      cacheMisses: 0,
      validationFailures: 0,
      averageShuffleTime: 0
    };
    this.config = { ...DEFAULT_QRNG_CONFIG, ...options.config };
    this.qrngClient = new QRNGClient(this.config);
    this.cache = options.cache || new MemoryCache({
      ttl: this.config.cacheTTL,
      maxEntries: this.config.minCacheSize * 2
    });
    this.enableValidation = options.enableValidation ?? this.config.enableValidation;
    this.fallbackToCsprng = options.fallbackToCsprng ?? true;
  }
  /**
   * Shuffle an array using Fisher-Yates algorithm with QRNG or CSPRNG
   *
   * @param array - Array to shuffle
   * @returns Shuffle result with metadata
   */
  async shuffle(array) {
    const startTime = Date.now();
    this.metrics.totalShuffles++;
    try {
      const randomBytes = await this.getRandomBytes(array.length);
      const shuffled = this.fisherYatesShuffle([...array], randomBytes.bytes);
      let validated = false;
      let entropy;
      if (this.enableValidation && randomBytes.source === "qrng") {
        validated = this.validateRandomness(randomBytes.bytes);
        entropy = RandomnessValidator.calculateEntropy(randomBytes.bytes);
        if (!validated) {
          this.metrics.validationFailures++;
          if (this.fallbackToCsprng) {
            const csprngBytes = this.generateCSPRNGBytes(array.length);
            const csprngShuffled = this.fisherYatesShuffle([...array], csprngBytes);
            this.metrics.csprngShuffles++;
            return {
              shuffled: csprngShuffled,
              source: "csprng",
              validated: true,
              metrics: this.updateMetrics(startTime)
            };
          }
        }
      }
      if (randomBytes.source === "qrng") {
        this.metrics.qrngShuffles++;
      } else {
        this.metrics.csprngShuffles++;
      }
      return {
        shuffled,
        source: randomBytes.source,
        validated: validated || randomBytes.source === "csprng",
        entropy,
        metrics: this.updateMetrics(startTime)
      };
    } catch (error) {
      if (this.fallbackToCsprng) {
        const csprngBytes = this.generateCSPRNGBytes(array.length);
        const shuffled = this.fisherYatesShuffle([...array], csprngBytes);
        this.metrics.csprngShuffles++;
        return {
          shuffled,
          source: "csprng",
          validated: true,
          metrics: this.updateMetrics(startTime)
        };
      }
      throw new QRNGError(
        "shuffle_error" /* SHUFFLE_ERROR */,
        "Failed to shuffle array",
        error instanceof Error ? error : void 0
      );
    }
  }
  /**
   * Pre-fetch QRNG bytes and store in cache
   *
   * @param count - Number of cache entries to pre-fetch
   */
  async prefetchCache(count = this.config.minCacheSize) {
    try {
      const promises = Array.from(
        { length: count },
        () => this.fetchAndCacheBytes(this.config.blockSize)
      );
      await Promise.all(promises);
    } catch (error) {
      console.warn("Failed to pre-fetch QRNG cache:", error);
    }
  }
  /**
   * Get random bytes from cache or fetch new ones
   */
  async getRandomBytes(length) {
    const cached = await this.cache.get(length);
    if (cached) {
      this.metrics.cacheHits++;
      return { bytes: cached, source: "qrng" };
    }
    this.metrics.cacheMisses++;
    try {
      const bytes = await this.qrngClient.fetchRandomBytes(length);
      if (bytes.length > length) {
        await this.cache.set(bytes.slice(length), this.enableValidation);
      }
      return { bytes: bytes.slice(0, length), source: "qrng" };
    } catch (error) {
      if (this.fallbackToCsprng) {
        return {
          bytes: this.generateCSPRNGBytes(length),
          source: "csprng"
        };
      }
      throw error;
    }
  }
  /**
   * Fisher-Yates shuffle algorithm
   * Modern version (Durstenfeld's) that shuffles in-place with O(n) time
   *
   * @param array - Array to shuffle (will be modified)
   * @param randomBytes - Random bytes for shuffle (need at least array.length bytes)
   * @returns Shuffled array
   */
  fisherYatesShuffle(array, randomBytes) {
    if (randomBytes.length < array.length) {
      throw new QRNGError(
        "shuffle_error" /* SHUFFLE_ERROR */,
        `Insufficient random bytes: need ${array.length}, got ${randomBytes.length}`
      );
    }
    const reader = new ByteIndexReader(randomBytes);
    for (let i = array.length - 1; i > 0; i--) {
      const j = reader.nextIndex(i + 1);
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }
  /**
   * Generate cryptographically secure pseudo-random bytes using the Web
   * Crypto API (globalThis.crypto.getRandomValues) — available natively in
   * browsers and in Node.js 19+, unlike the Node-only `crypto` module this
   * used to import. That import broke every browser consumer of this
   * package: bundlers externalize Node's `crypto` module in client code, so
   * `import { randomBytes } from 'crypto'` throws the moment this module
   * loads (destructuring is a property access on the externalized stub) —
   * not just when this method is actually called.
   *
   * @param length - Number of bytes to generate
   * @returns Array of random bytes (0-255)
   */
  generateCSPRNGBytes(length) {
    const buffer = new Uint8Array(length);
    globalThis.crypto.getRandomValues(buffer);
    return Array.from(buffer);
  }
  /**
   * Validate randomness using statistical tests
   *
   * @param bytes - Random bytes to validate
   * @returns True if bytes pass validation
   */
  validateRandomness(bytes) {
    if (bytes.length < 256) {
      return new Set(bytes).size >= Math.ceil(bytes.length / 2);
    }
    const results = RandomnessValidator.runAllTests(bytes, this.config.chiSquaredAlpha);
    return RandomnessValidator.allTestsPassed(results);
  }
  /**
   * Fetch bytes from QRNG and add to cache
   */
  async fetchAndCacheBytes(length) {
    try {
      const bytes = await this.qrngClient.fetchRandomBytes(length);
      const validated = this.enableValidation ? this.validateRandomness(bytes) : true;
      await this.cache.set(bytes, validated);
    } catch (error) {
      console.warn("Failed to fetch and cache QRNG bytes:", error);
    }
  }
  /**
   * Update metrics with elapsed time
   */
  updateMetrics(startTime) {
    const elapsedTime = Date.now() - startTime;
    this.metrics.averageShuffleTime = (this.metrics.averageShuffleTime * (this.metrics.totalShuffles - 1) + elapsedTime) / this.metrics.totalShuffles;
    return { ...this.metrics };
  }
  /**
   * Get current metrics
   */
  getMetrics() {
    return { ...this.metrics };
  }
  /**
   * Reset metrics
   */
  resetMetrics() {
    this.metrics = {
      totalShuffles: 0,
      qrngShuffles: 0,
      csprngShuffles: 0,
      cacheHits: 0,
      cacheMisses: 0,
      validationFailures: 0,
      averageShuffleTime: 0
    };
  }
  /**
   * Get cache status
   */
  async getCacheStatus() {
    return await this.cache.getStats();
  }
  /**
   * Clear cache
   */
  async clearCache() {
    await this.cache.clear();
  }
  /**
   * Close service and cleanup resources
   */
  async close() {
    await this.cache.close();
  }
  /**
   * Get QRNG client metrics
   */
  getQRNGMetrics() {
    return this.qrngClient.getMetrics();
  }
};
function createShuffleService(options) {
  return new ShuffleService(options);
}
export {
  ANIMATIONS,
  ActionType,
  ActionTypeSchema,
  BettingRound,
  COMMUNITY_CARDS,
  CardSchema,
  DEFAULT_GAME_CONFIG,
  DEFAULT_QRNG_CONFIG,
  Deck,
  DeckSchema,
  GRID_CENTER,
  GRID_CORNERS,
  GRID_DIAMOND,
  GRID_LINES,
  GRID_LINES_COMPLETE_BEFORE_CENTER,
  GRID_LINES_SNAKE,
  GRID_LINES_STRAIGHT,
  GRID_POSITIONS,
  GRID_REVEAL_PHASES,
  GameConfigSchema,
  GameEventType,
  GameHistorySchema,
  GamePhase,
  GamePhaseManager,
  GamePhaseSchema,
  GameTableSchema,
  GridCardSchema,
  GridPoker,
  GridPositionSchema,
  HAND_RANKING_NAMES,
  HAND_RANKING_VALUES,
  HAND_SIZE,
  HOLE_CARDS,
  HandEvaluationSchema,
  HandEvaluator,
  HandRanking,
  HandRankingSchema,
  JEWELS,
  JEWEL_HAND_RANKING_NAMES,
  Jewel,
  JewelHandEvaluationSchema,
  JewelHandRanking,
  JewelHandRankingSchema,
  JewelSchema,
  JewelWinnerInfoSchema,
  MemoryCache,
  PLAYERS_PER_TABLE,
  PlayerActionSchema,
  PlayerSchema,
  PlayerStatsSchema,
  PlayerStatus,
  PlayerStatusSchema,
  QRNGClient,
  QRNGError,
  QRNGErrorType,
  RANKS,
  RANK_VALUES,
  RandomnessValidator,
  Rank,
  RankSchema,
  RedisCache,
  SPECIAL_CARD_DEAL_CHANCE,
  SPECIAL_CARD_INFO,
  SPECIAL_CARD_TIERS,
  SPECIAL_CARD_TIER_WEIGHTS,
  SPECIAL_CARD_TOTAL_CARD_WEIGHT,
  SPECIAL_CARD_TOTAL_TIER_WEIGHT,
  SUITS,
  ShuffleService,
  SpecialCardSign,
  SpecialCardSignSchema,
  SpecialCardType,
  SpecialCardTypeSchema,
  Suit,
  SuitSchema,
  TIMEOUTS,
  WinnerInfoSchema,
  activeBlockedMove,
  blockedBettingMove,
  concealFromHolder,
  createMetrics,
  createRedisCache,
  createShuffleService,
  createShuffledDeck,
  dealSpecialCards,
  evaluatePlayerJewelHand,
  evaluatePlayerRankHand,
  getGridColumn,
  getGridCoordinates,
  getGridRow,
  getInsightView,
  getShapeSetForPlayer,
  getViewerFacingTable,
  holderView,
  insightCardOf,
  isActionBlocked,
  isHiddenCard,
  isMaskedCard,
  isPositionInPhase,
  isRealCard,
  lineOverview,
  lineTakenAway,
  livePots,
  nextCardAdvice,
  playerLines,
  privateRevealHolderIds,
  resolveForView,
  resolveImpersonator,
  resolveInstantSpecials,
  resolveLimbo,
  resolveSeer,
  resolveThief,
  sameLine,
  specialsOf,
  specialsTurnedOver,
  withoutSpecials
};
